<template>
  <g
    id="Front_Wheel"
    v-on:click="changeSeverity('rightFrontWheel')"
    :class="severityClass"
  >
    <g>
      <path
        class="cls-456"
        d="M445.51,485.7l-.32,.82c-.15-.06-.3-.13-.45-.22-.06-.04-.12-.07-.18-.11-.28-.2-.54-.44-.76-.73-.47-.61-.79-1.41-.88-2.28-.13-1.28,.17-2.52,.47-3.72l.04-.14c.3-1.22,.55-2.41,.35-3.54-.28-1.6-1.39-2.85-2.56-4.17-.59-.67-1.2-1.35-1.7-2.1-.18-.26-.34-.53-.49-.8-.77-1.43-1.19-3.05-1.21-4.67,.29-.14,.59-.28,.88-.41-.04,1.65,.36,3.32,1.16,4.76,.12,.22,.25,.43,.39,.64,.47,.7,1.06,1.36,1.63,2.01,1.2,1.36,2.44,2.76,2.76,4.6,.23,1.3-.04,2.58-.36,3.9l-.04,.14c-.28,1.13-.56,2.3-.45,3.42,.05,.45,.19,.98,.45,1.45,.17,.31,.39,.59,.66,.81,.05,.04,.11,.08,.16,.12,.13,.09,.28,.17,.44,.23Z"
      />
      <path
        class="cls-456"
        d="M447.64,483.55s-.01,.03-.02,.04c-.05,.14-.11,.27-.18,.41-.23,.49-.49,.95-.8,1.4l-.72-.5c.25-.36,.48-.75,.67-1.15,.02-.04,.04-.07,.05-.11,.03-.05,.05-.1,.07-.16,.95-2.13,1.04-4.61,.21-6.8-.49-1.28-1.24-2.41-2.05-3.6-.51-.76-1.04-1.54-1.48-2.36-.58-1.06-1.01-2.17-1.32-3.32-.43-1.63-.58-3.33-.44-5.02,.31-.12,.61-.24,.92-.35-.18,1.66-.06,3.36,.34,4.98,.29,1.15,.71,2.26,1.27,3.29,.43,.79,.94,1.55,1.44,2.29,.79,1.18,1.62,2.4,2.14,3.78,.87,2.3,.81,4.91-.11,7.18Z"
      />
    </g>
    <path
      class="cls-254"
      d="M454.89,490.52h0s-.65-.48-.65-.48h0s-.71-.52-.71-.52l-.34-.25-1.53-1.11-.14-.11h0s-1.24-.9-1.24-.9l-.22-.16c-.2-.39-.5-.73-.9-.97,0,0-1.59-1.01-1.78-1.05-.04-.01-.07-.02-.12-.02-.03-.02-.06-.03-.08-.03-.21-.05-.43-.04-.65,.02-2.52,3.14-4.02,7.13-4.02,11.47,0,.94,.07,1.86,.21,2.76,.19,.26,.43,.43,.71,.5,.02,0,.04,0,.07,0,.04,.02,.08,.04,.13,.05,.08,.02,.51,0,.96-.02,.29-.02,.58-.03,.8-.04,.19-.01,.31-.02,.31-.02,.37-.02,.73-.12,1.04-.29l.3-.02h.07s.72-.04,.72-.04c-.27-.5-.33-1.1-.1-1.67,.11-.26,.27-.49,.47-.68l1.17-4.59c-.12-.12-.22-.26-.32-.41-.54-.94-.22-2.13,.72-2.68,.94-.54,2.13-.22,2.68,.72,.02,.04,.04,.07,.05,.11-.14,.18-.27,.37-.39,.56l.59,.43,7.89,5.77-7.7,.41h-.25s-.83,.05-.83,.05l-.26,.02-.31,.02-.79,.04c.05,.59,.16,1.18,.32,1.74l.6-.03,10.05-.53,.71-2.78-7.22-5.27Z"
    />
    <g>
      <g>
        <polygon
          class="cls-566"
          points="461.99 495.2 461.29 497.97 448.81 498.63 446.14 498.77 446.04 497.02 449.28 496.85 460.46 496.26 451.16 489.46 448.65 487.63 449.68 486.21 451.39 487.45 461.99 495.2"
        />
        <g class="cls-738">
          <path
            class="cls-253"
            d="M448.91,498.32l.38-1.48-3.24,.17,.09,1.75,2.67-.14c.04-.1,.07-.2,.1-.31Z"
          />
          <path
            class="cls-253"
            d="M451.36,488.67c.1-.41,.11-.82,.02-1.21l-1.71-1.25-1.04,1.42,2.51,1.84,.2-.8Z"
          />
        </g>
      </g>
      <g>
        <path
          class="cls-418"
          d="M444.15,484.97c-1.99,3.8-3.06,8.01-3.12,12.29,0,.5,.4,1.01,.87,1.13,.49,.12,.98,.25,1.47,.37,.47,.12,.96-.17,1.09-.65,1.04-4.09,2.08-8.18,3.12-12.26,.12-.48-.17-.97-.65-1.09-.49-.12-.98-.25-1.47-.37-.47-.12-1.06,.14-1.3,.58Z"
        />
        <path
          class="cls-22"
          d="M447.06,484.32c-1.1-.28-2.42,1.14-2.94,3.18-.26,1.02-.27,2-.08,2.76,.19,.76-.02,1.58-.55,2.16-.53,.58-.99,1.44-1.25,2.46-.52,2.04-.04,3.92,1.06,4.2,.18,.05,2.07-.08,2.07-.08,1.09-.06,2.02-.82,2.29-1.88l2.29-8.99c.27-1.06-.18-2.18-1.12-2.75,0,0-1.6-1.01-1.78-1.06Z"
        />
        <path
          class="cls-717"
          d="M447.25,484.37c-1.1-.28-2.42,1.14-2.94,3.18-.26,1.02-.27,2-.08,2.76,.19,.76-.02,1.58-.55,2.16-.53,.58-.99,1.44-1.25,2.46-.52,2.04-.04,3.92,1.06,4.2,.18,.05,2.07-.08,2.07-.08,1.09-.06,2.02-.82,2.29-1.88l2.29-8.99c.27-1.06-.18-2.18-1.12-2.75,0,0-1.6-1.01-1.78-1.06Z"
        />
        <path
          class="cls-532"
          d="M445.5,497.5c0-.41-.33-.75-.75-.75s-.75,.33-.75,.75,.33,.75,.75,.75,.75-.33,.75-.75Z"
        />
        <path
          class="cls-532"
          d="M448.13,486.57c0-.41-.33-.75-.75-.75s-.75,.33-.75,.75,.33,.75,.75,.75,.75-.33,.75-.75Z"
        />
      </g>
    </g>
    <path
      class="cls-273"
      d="M463.54,494.54c0,.39-.03,.79-.08,1.2-.01,.06-.02,.11-.04,.17,0,.02,0,.04-.01,.06-.27,.99-1.32,1.39-2.28,1.82-.18,.09-.36,.17-.52,.26l-.31-.41-.02-.02-.44-.57s0,0-.01-.01c-.11-.14-.22-.29-.32-.43-.71-.95-1.33-1.94-1.88-2.98l-2.57-4.86-.42-.8-.23-.44-.51-.96-.51-.97-.44-.83-.88-1.66-.37-.7-.07-.13-.32-.6-.39-.72-3.98-7.51-.62-1.17-1.48-2.8-.11-.21-.41-.77-.12-.22-.24-.44-.03-.06-.09-.17-.07-.14-.11-.2-.12-.23-.49-.93-.26,.14c-.27,.14-.59,.05-.75-.2-.02-.02-.02-.03-.03-.04l-.93-1.77-.24-.44-.2-.38-1.08-2.04-.16-.29-.05-.1h0s-.74-1.41-.74-1.41l-3.45-6.51-11.72-22.18-2.2-4.16c-.09-.16,.01-.38,.22-.49l.37-.2-.25-.46-.13-.25-.37,.2c-.21,.11-.44,.06-.53-.1l-.09-.17-1.89-3.55-7.82-14.7c-.24-.46-.07-1.02,.39-1.27l4.65-2.46c.11,.08,.21,.19,.28,.32l9.79,18.42c.09,.16-.01,.38-.21,.49l-.37,.2,.37,.71,.37-.2c.21-.11,.44-.06,.53,.1l14.21,26.87c.45-.2,.9-.39,1.35-.57l3.46,6.55,.61,1.16,.05,.09,.14,.27,.7,1.33,.55,1.03,.2,.39,.18,.35,.85,1.6c.15,.28,.04,.63-.24,.78l-.21,.11s.24,.44,.62,1.16c.04,.07,.07,.15,.12,.22,.04,.07,.07,.14,.11,.21,.02,.05,.05,.09,.07,.14,.03,.06,.06,.11,.09,.17,.01,.02,.02,.04,.03,.05,.08,.14,.16,.29,.24,.45,.04,.07,.08,.15,.12,.22,.13,.25,.27,.5,.41,.77,.04,.07,.07,.14,.11,.21,1.72,3.26,4.03,7.61,4.26,8.05,.12,.23,.25,.47,.37,.7,.11,.21,.22,.42,.33,.63,.41,.77,.81,1.53,1.22,2.3,.31,.58,.62,1.17,.93,1.75,.12,.23,.24,.45,.36,.68,.26,.5,.53,1.01,.8,1.51,.18,.34,.36,.67,.54,1.01,.33,.61,.65,1.23,.97,1.84,.08,.15,.16,.3,.24,.45,.02,.04,.04,.08,.07,.12,.03,.07,.07,.13,.11,.2,.13,.23,.25,.47,.38,.7,.05,.1,.11,.19,.16,.29,.09,.15,.17,.3,.25,.45,.05,.1,.11,.2,.16,.3,.28,.53,.55,1.06,.8,1.61,.27,.59,.51,1.18,.71,1.79,.31,.93,.51,1.88,.55,2.87,.01,.13,.01,.27,.01,.41Z"
    />
    <g>
      <g>
        <g>
          <g>
            <rect
              class="cls-266"
              x="454.31"
              y="504.23"
              width=".3"
              height="21.23"
              transform="translate(352.01 -164.2) rotate(32.86)"
            />
            <rect
              class="cls-717"
              x="448.24"
              y="522.91"
              width=".5"
              height="2.36"
              transform="translate(356 -159.48) rotate(32.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="457.28"
              y="505.01"
              width=".3"
              height="21.23"
              transform="translate(247.58 -140.94) rotate(23.85)"
            />
            <rect
              class="cls-717"
              x="452.73"
              y="524.5"
              width=".5"
              height="2.36"
              transform="translate(251.22 -138.26) rotate(23.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="466.38"
              y="504.48"
              width=".3"
              height="21.23"
              transform="translate(-27.59 26.4) rotate(-3.15)"
            />
            <rect
              class="cls-717"
              x="466.88"
              y="524.9"
              width=".5"
              height="2.36"
              transform="translate(-28.23 26.49) rotate(-3.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="469.24"
              y="503.37"
              width=".3"
              height="21.23"
              transform="translate(-97.7 110.35) rotate(-12.15)"
            />
            <rect
              class="cls-717"
              x="471.45"
              y="523.56"
              width=".5"
              height="2.36"
              transform="translate(-99.86 111.02) rotate(-12.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="476.3"
              y="497.59"
              width=".3"
              height="21.23"
              transform="translate(-213.9 414.94) rotate(-39.15)"
            />
            <rect
              class="cls-717"
              x="483.14"
              y="515.55"
              width=".5"
              height="2.36"
              transform="translate(-217.71 421.17) rotate(-39.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="477.95"
              y="495.01"
              width=".3"
              height="21.23"
              transform="translate(-217.52 524.4) rotate(-48.15)"
            />
            <rect
              class="cls-717"
              x="486.04"
              y="511.78"
              width=".5"
              height="2.36"
              transform="translate(-220.25 533) rotate(-48.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="480.26"
              y="486.18"
              width=".3"
              height="21.23"
              transform="translate(-122.92 833.84) rotate(-75.15)"
            />
            <rect
              class="cls-717"
              x="490.79"
              y="498.44"
              width=".5"
              height="2.36"
              transform="translate(-117.73 846.23) rotate(-75.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="480.09"
              y="483.12"
              width=".3"
              height="21.23"
              transform="translate(-59.89 921.14) rotate(-84.15)"
            />
            <rect
              class="cls-717"
              x="490.92"
              y="493.68"
              width=".5"
              height="2.36"
              transform="translate(-51.17 933.04) rotate(-84.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="476.77"
              y="474.63"
              width=".3"
              height="21.23"
              transform="translate(196.47 1105.13) rotate(-111.15)"
            />
            <rect
              class="cls-717"
              x="486.92"
              y="480.1"
              width=".5"
              height="2.36"
              transform="translate(214.13 1109.3) rotate(-111.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="474.83"
              y="472.26"
              width=".3"
              height="21.23"
              transform="translate(296.03 1136.13) rotate(-120.15)"
            />
            <rect
              class="cls-717"
              x="484.23"
              y="476.17"
              width=".5"
              height="2.36"
              transform="translate(315.04 1136.04) rotate(-120.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="467.15"
              y="467.33"
              width=".3"
              height="21.23"
              transform="translate(600.67 1132.93) rotate(-147.15)"
            />
            <rect
              class="cls-717"
              x="473.01"
              y="467.53"
              width=".5"
              height="2.36"
              transform="translate(616.61 1119.18) rotate(-147.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="464.19"
              y="466.55"
              width=".3"
              height="21.23"
              transform="translate(696.08 1101.34) rotate(-156.15)"
            />
            <rect
              class="cls-717"
              x="468.53"
              y="465.93"
              width=".5"
              height="2.36"
              transform="translate(708.68 1083.87) rotate(-156.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="455.08"
              y="467.08"
              width=".3"
              height="21.23"
              transform="translate(936.01 929.66) rotate(176.85)"
            />
            <rect
              class="cls-717"
              x="454.37"
              y="465.54"
              width=".5"
              height="2.36"
              transform="translate(934.19 907.75) rotate(176.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="452.22"
              y="468.19"
              width=".3"
              height="21.23"
              transform="translate(995.41 851.64) rotate(167.85)"
            />
            <rect
              class="cls-717"
              x="449.81"
              y="466.88"
              width=".5"
              height="2.36"
              transform="translate(988.53 830.92) rotate(167.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="445.17"
              y="473.97"
              width=".3"
              height="21.23"
              transform="translate(1096.59 579.31) rotate(140.86)"
            />
            <rect
              class="cls-717"
              x="438.12"
              y="474.88"
              width=".5"
              height="2.36"
              transform="translate(1078.89 568.47) rotate(140.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="443.51"
              y="476.55"
              width=".3"
              height="21.23"
              transform="translate(1102.55 481.74) rotate(131.85)"
            />
            <rect
              class="cls-717"
              x="435.22"
              y="478.65"
              width=".5"
              height="2.36"
              transform="translate(1083.43 475.58) rotate(131.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="441.2"
              y="485.38"
              width=".3"
              height="21.23"
              transform="translate(1033.89 196.51) rotate(104.85)"
            />
            <rect
              class="cls-717"
              x="430.47"
              y="492"
              width=".5"
              height="2.36"
              transform="translate(1017.82 203.27) rotate(104.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="441.38"
              y="488.44"
              width=".3"
              height="21.23"
              transform="translate(982.99 110.7) rotate(95.85)"
            />
            <rect
              class="cls-717"
              x="430.33"
              y="496.75"
              width=".5"
              height="2.36"
              transform="translate(969.82 120.35) rotate(95.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="444.69"
              y="496.94"
              width=".3"
              height="21.23"
              transform="translate(757.74 -90.43) rotate(68.85)"
            />
            <rect
              class="cls-717"
              x="434.33"
              y="510.34"
              width=".5"
              height="2.36"
              transform="translate(754.85 -78.35) rotate(68.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="446.63"
              y="499.31"
              width=".3"
              height="21.23"
              transform="translate(663.29 -132.54) rotate(59.85)"
            />
            <rect
              class="cls-717"
              x="437.02"
              y="514.27"
              width=".5"
              height="2.36"
              transform="translate(663.38 -121.55) rotate(59.85)"
            />
          </g>
        </g>
        <g>
          <g>
            <rect
              class="cls-266"
              x="442.13"
              y="479.8"
              width=".3"
              height="21.23"
              transform="translate(-78.87 896.03) rotate(-85.85)"
            />
            <rect
              class="cls-717"
              x="431.06"
              y="488.44"
              width=".5"
              height="2.36"
              transform="translate(-88.25 884.35) rotate(-85.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="443.3"
              y="476.97"
              width=".3"
              height="21.23"
              transform="translate(-132.24 808.47) rotate(-76.85)"
            />
            <rect
              class="cls-717"
              x="432.48"
              y="483.9"
              width=".5"
              height="2.36"
              transform="translate(-138.07 796.12) rotate(-76.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="449.2"
              y="470.01"
              width=".3"
              height="21.23"
              transform="translate(-207.76 514.17) rotate(-49.85)"
            />
            <rect
              class="cls-717"
              x="440.69"
              y="472.36"
              width=".5"
              height="2.36"
              transform="translate(-205.33 505.23) rotate(-49.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="451.81"
              y="468.4"
              width=".3"
              height="21.23"
              transform="translate(-203.23 412.31) rotate(-40.85)"
            />
            <rect
              class="cls-717"
              x="444.51"
              y="469.52"
              width=".5"
              height="2.36"
              transform="translate(-199.54 405.55) rotate(-40.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="460.67"
              y="466.24"
              width=".3"
              height="21.23"
              transform="translate(-100.74 124.15) rotate(-13.85)"
            />
            <rect
              class="cls-717"
              x="457.93"
              y="465"
              width=".5"
              height="2.36"
              transform="translate(-98.28 123.24) rotate(-13.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="463.73"
              y="466.48"
              width=".3"
              height="21.23"
              transform="translate(-38.64 40.89) rotate(-4.85)"
            />
            <rect
              class="cls-717"
              x="462.69"
              y="464.95"
              width=".5"
              height="2.36"
              transform="translate(-37.75 40.81) rotate(-4.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="472.16"
              y="469.94"
              width=".3"
              height="21.23"
              transform="translate(216.09 -142.63) rotate(22.15)"
            />
            <rect
              class="cls-717"
              x="476.21"
              y="469.19"
              width=".5"
              height="2.36"
              transform="translate(212.52 -144.93) rotate(22.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="474.5"
              y="471.92"
              width=".3"
              height="21.23"
              transform="translate(318.05 -175.95) rotate(31.15)"
            />
            <rect
              class="cls-717"
              x="480.09"
              y="471.95"
              width=".5"
              height="2.36"
              transform="translate(313.98 -180.25) rotate(31.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="479.29"
              y="479.68"
              width=".3"
              height="21.23"
              transform="translate(642.94 -175.68) rotate(58.15)"
            />
            <rect
              class="cls-717"
              x="488.53"
              y="483.32"
              width=".5"
              height="2.36"
              transform="translate(642.39 -186.36) rotate(58.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="480.02"
              y="482.66"
              width=".3"
              height="21.23"
              transform="translate(748.29 -140.75) rotate(67.15)"
            />
            <rect
              class="cls-717"
              x="490.05"
              y="487.83"
              width=".5"
              height="2.36"
              transform="translate(750.53 -152.71) rotate(67.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="479.33"
              y="491.76"
              width=".3"
              height="21.23"
              transform="translate(1015.19 60.46) rotate(94.14)"
            />
            <rect
              class="cls-717"
              x="490.2"
              y="501.99"
              width=".5"
              height="2.36"
              transform="translate(1027.76 50.39) rotate(94.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="478.17"
              y="494.59"
              width=".3"
              height="21.23"
              transform="translate(1079.1 154.38) rotate(103.15)"
            />
            <rect
              class="cls-717"
              x="488.77"
              y="506.53"
              width=".5"
              height="2.36"
              transform="translate(1094.69 147.04) rotate(103.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="472.26"
              y="501.55"
              width=".3"
              height="21.23"
              transform="translate(1168.5 481.26) rotate(130.15)"
            />
            <rect
              class="cls-717"
              x="480.57"
              y="518.08"
              width=".5"
              height="2.36"
              transform="translate(1187.75 486.56) rotate(130.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="469.66"
              y="503.16"
              width=".3"
              height="21.23"
              transform="translate(1161.23 595.1) rotate(139.15)"
            />
            <rect
              class="cls-717"
              x="476.75"
              y="520.92"
              width=".5"
              height="2.36"
              transform="translate(1179.3 605) rotate(139.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="460.79"
              y="505.32"
              width=".3"
              height="21.23"
              transform="translate(1032.02 906.48) rotate(166.15)"
            />
            <rect
              class="cls-717"
              x="463.32"
              y="525.43"
              width=".5"
              height="2.36"
              transform="translate(1039.73 926.94) rotate(166.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="457.74"
              y="505.09"
              width=".3"
              height="21.23"
              transform="translate(957.69 990.88) rotate(175.15)"
            />
            <rect
              class="cls-717"
              x="458.56"
              y="525.48"
              width=".5"
              height="2.36"
              transform="translate(960.51 1012.65) rotate(175.15)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="449.3"
              y="501.62"
              width=".3"
              height="21.23"
              transform="translate(672.54 1156.15) rotate(-157.85)"
            />
            <rect
              class="cls-717"
              x="445.05"
              y="521.25"
              width=".5"
              height="2.36"
              transform="translate(660.73 1174.2) rotate(-157.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="446.96"
              y="499.64"
              width=".3"
              height="21.23"
              transform="translate(565.85 1178.21) rotate(-148.85)"
            />
            <rect
              class="cls-717"
              x="441.17"
              y="518.49"
              width=".5"
              height="2.36"
              transform="translate(550.37 1192.75) rotate(-148.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="442.17"
              y="491.88"
              width=".3"
              height="21.23"
              transform="translate(248.88 1143.37) rotate(-121.85)"
            />
            <rect
              class="cls-717"
              x="432.73"
              y="507.12"
              width=".5"
              height="2.36"
              transform="translate(229.7 1144.31) rotate(-121.85)"
            />
          </g>
          <g>
            <rect
              class="cls-266"
              x="441.45"
              y="488.9"
              width=".3"
              height="21.23"
              transform="translate(152.74 1100.42) rotate(-112.85)"
            />
            <rect
              class="cls-717"
              x="431.21"
              y="502.61"
              width=".5"
              height="2.36"
              transform="translate(134.76 1097.02) rotate(-112.85)"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            class="cls-942"
            d="M503.68,492.04h0s0-.04,0-.05c-.02-.18-.04-.36-.06-.54-.01-.06-.02-.12-.02-.18h0c-.01-.07-.02-.14-.03-.2,0,0,0,0,0-.01-.27-2.18-.71-4.31-1.29-6.38,0,0,0,0,0,0-.07-.25-.14-.5-.22-.75h0c-.02-.07-.03-.13-.05-.19h0c-.65-2.1-1.44-4.13-2.38-6.07-.11-.24-.23-.47-.35-.7-.03-.06-.06-.12-.09-.18l-.02-.02c-1-1.94-2.12-3.79-3.39-5.54-.16-.21-.31-.42-.47-.63-.04-.05-.08-.11-.12-.16h0c-1.31-1.74-2.74-3.37-4.3-4.89h0c-.18-.18-.37-.36-.56-.54h-.01s-.05-.05-.07-.07-.04-.04-.07-.06t-.01-.01c-1.58-1.48-3.29-2.84-5.09-4.06-.21-.14-.43-.29-.65-.43-.06-.04-.11-.07-.17-.11h0c-.47-.3-.94-.6-1.42-.88-.4-.24-.8-.47-1.2-.68-.33-.18-.67-.36-1.01-.54-.68-.35-1.38-.69-2.09-1.01-.65-.3-1.31-.58-1.98-.84-3.92-1.53-8.12-2.51-12.5-2.83-.26-.02-.52-.03-.78-.05h0c-.06,0-.13,0-.2-.01-.72-.04-1.44-.05-2.17-.05-1.47,0-2.92,.07-4.34,.22h0c-.26,.03-.51,.05-.78,.09h0c-.06,0-.13,.01-.19,.02h0c-2.19,.27-4.33,.71-6.4,1.31,0,0,0,0,0-.01-.25,.07-.5,.14-.74,.22-.06,.02-.13,.04-.19,.06h0c-.88,.27-1.76,.56-2.62,.89,0,0,0,0-.01,0-.46,.17-.91,.35-1.36,.55-.25,.1-.5,.21-.75,.33-.68,.3-1.35,.62-2.01,.96,0,0,0,0,0,0-.06,.03-.12,.06-.18,.09,0,0,0,0,0,0-.26,.14-.53,.27-.79,.41-.47,.25-.93,.51-1.4,.79-.16,.09-.31,.18-.47,.28-.17,.1-.34,.21-.5,.32-.02,.02-.05,.03-.07,.04-.22,.14-.44,.28-.66,.43-.56,.36-1.12,.74-1.66,1.14,0,0,0,0-.01,0-.21,.16-.42,.3-.63,.46-.02,.02-.05,.04-.07,.05-.03,.02-.06,.04-.09,.06h0s0,.02-.01,.02c-.27,.2-.54,.41-.81,.63-.39,.31-.78,.62-1.15,.95-1.01,.86-1.99,1.77-2.91,2.72,0,0,0,0,0,.01h0c-.18,.18-.35,.36-.52,.55h0s0,.01,0,.01c0,0,0,0,0,0-.05,.05-.09,.09-.13,.13t0,.01c-1.48,1.59-2.84,3.29-4.06,5.08h0c-.14,.22-.29,.44-.43,.66,0,0,0,0,0,0-.02,.02-.03,.04-.05,.07-.02,.03-.03,.05-.05,.09h0c-1.18,1.82-2.23,3.73-3.12,5.73-.11,.24-.21,.48-.31,.72-.03,.06-.05,.12-.08,.19-.85,1.99-1.54,4.06-2.08,6.18h0c-.06,.25-.12,.49-.18,.74,0,0,0,.01,0,.02h0c-.02,.07-.03,.14-.04,.2h0c-.48,2.1-.81,4.25-.97,6.45v.02c-.01,.07-.02,.15-.02,.22,0,.11-.02,.22-.02,.33,0,.07,0,.14-.01,.21h0c0,.07-.01,.14-.01,.2h0c-.04,.73-.06,1.45-.06,2.17,0,6.46,1.43,12.6,3.99,18.1,.18,.39,.36,.78,.56,1.16,.16,.3,.31,.61,.47,.91,.93,1.74,1.98,3.41,3.14,5,0,0-.01,0-.02-.01,.14,.19,.28,.39,.42,.58,.02,.02,.03,.04,.05,.06,.04,.05,.07,.1,.11,.15,1.31,1.74,2.76,3.38,4.32,4.89,.18,.18,.37,.36,.56,.54t.01,0s.1,.09,.14,.13c1.59,1.48,3.31,2.84,5.11,4.07h-.01c.21,.14,.43,.29,.65,.43h0s.06,.04,.09,.06c.03,.02,.06,.04,.09,.05,0,0,0,0,.01,0,1.81,1.18,3.71,2.22,5.7,3.11,.24,.11,.48,.21,.72,.31,.06,.03,.12,.05,.19,.08,1.99,.85,4.05,1.54,6.18,2.08h0c.16,.04,.31,.07,.47,.11,.1,.03,.19,.05,.28,.07h0c.06,.02,.12,.03,.19,.04,2.09,.48,4.24,.82,6.44,.97h.01c.26,.02,.51,.03,.77,.05h0c.06,0,.13,0,.2,.01h0c.72,.04,1.44,.06,2.16,.06,9.41,0,18.1-3.02,25.17-8.15,0,0,0,0,0,.01,.21-.16,.42-.3,.63-.47,.05-.04,.11-.08,.16-.12,1.74-1.31,3.37-2.76,4.89-4.32,.18-.19,.36-.37,.54-.56,.05-.05,.1-.1,.14-.15,1.48-1.59,2.84-3.31,4.06-5.11h0c.13-.18,.26-.37,.39-.57,.02-.02,.03-.04,.05-.07h0s0-.02,0-.02h0s.02-.02,.02-.03c.01-.02,.02-.03,.03-.05,.02-.02,.03-.04,.04-.06h0c1.18-1.82,2.23-3.73,3.12-5.73,.11-.24,.21-.48,.31-.72,.03-.06,.05-.12,.08-.19h0c.85-2,1.54-4.08,2.07-6.21,0,.01,0,.02,0,.03,.05-.21,.11-.43,.16-.65,0-.04,.02-.07,.03-.11h0c.02-.07,.03-.13,.04-.2,.48-2.1,.81-4.26,.97-6.46,0,0,0,.01,0,.02,.02-.26,.03-.52,.05-.78h0c0-.07,0-.13,.01-.2h0c.04-.72,.06-1.44,.06-2.16,0-1.47-.08-2.92-.22-4.36Zm-73.19,12.92c-.13-.44-.25-.88-.35-1.33-.06-.25-.11-.49-.16-.74-.44-2.09-.67-4.26-.67-6.49,0-9.66,4.34-18.31,11.18-24.1,.3-.26,.6-.5,.91-.74,.43-.34,.86-.66,1.31-.97,.26-.18,.52-.36,.78-.54,.04-.03,.08-.05,.12-.08,.28-.18,.56-.36,.85-.54,.09-.05,.18-.11,.27-.16,.21-.12,.42-.25,.63-.36,1.12-.64,2.29-1.2,3.49-1.7,.45-.19,.91-.36,1.38-.53,.02,0,.03-.01,.05-.02,.32-.12,.64-.22,.96-.33h0s.01,0,.02,0c1.03-.34,2.09-.62,3.17-.83,2.08-.43,4.24-.66,6.45-.66,.98,0,1.96,.04,2.92,.13,.73,.07,1.45,.16,2.16,.28,.36,.05,.72,.12,1.08,.19,.34,.06,.68,.14,1.02,.22,.36,.08,.71,.17,1.06,.27,5.86,1.57,11.05,4.8,15.03,9.14,5.15,5.62,8.3,13.11,8.3,21.34,0,17.44-14.13,31.57-31.57,31.57-14.2,0-26.21-9.37-30.18-22.27-.07-.25-.14-.49-.21-.73Z"
          />
          <path
            class="cls-717"
            d="M472.85,459.6s-.02-.01-.03-.01c-.77-.25-1.54-.47-2.32-.67-.35-.1-.71-.18-1.07-.26-.34-.08-.68-.15-1.02-.22-.36-.07-.72-.14-1.08-.19-.81-.14-1.63-.25-2.46-.34-1.31-.13-2.65-.2-4-.2-4.08,0-8.02,.63-11.71,1.81-.52,.16-1.03,.33-1.54,.52,0,0-.01,0-.02,0-.07,.03-.13,.05-.2,.07-.39,.14-.77,.29-1.16,.45-.25,.1-.5,.21-.75,.32-1.1,.48-2.17,1.01-3.22,1.58-.07,.03-.13,.07-.19,.11h0c-.49,.27-.97,.55-1.44,.85-.17,.1-.33,.2-.5,.31-.02,.01-.04,.03-.06,.04-.22,.14-.45,.29-.67,.45-.09,.05-.18,.12-.27,.18-.65,.44-1.28,.9-1.91,1.38-.29,.22-.57,.45-.86,.68-8.66,7.09-14.18,17.87-14.18,29.94,0,1.74,.11,3.45,.34,5.13,0,.01,0,.02,0,.03,.13,1.03,.31,2.04,.52,3.03,.05,.25,.11,.49,.17,.74,.1,.45,.22,.89,.34,1.34,.06,.25,.13,.49,.21,.73,4.74,16,19.55,27.68,37.09,27.68,21.37,0,38.69-17.32,38.69-38.68,0-17.19-11.21-31.76-26.71-36.8Zm-43.21,45.57c-.13-.44-.25-.88-.35-1.33-.06-.25-.11-.5-.17-.74-.45-2.16-.69-4.4-.69-6.7,0-10.05,4.56-19.02,11.73-24.97,.29-.24,.58-.47,.87-.7,.39-.3,.78-.59,1.18-.88,.28-.2,.57-.4,.86-.58,.02-.01,.03-.02,.05-.03,.32-.21,.64-.41,.97-.62,.07-.05,.15-.09,.22-.13,.22-.13,.44-.26,.68-.39,1.11-.63,2.26-1.18,3.44-1.67,.45-.19,.91-.36,1.37-.53,.03-.02,.06-.03,.1-.04,.32-.12,.64-.22,.96-.33,0-.01,.01-.01,.02-.02,1.17-.37,2.35-.68,3.57-.93,2.08-.42,4.22-.63,6.41-.63,.95,0,1.89,.04,2.81,.12,.82,.07,1.63,.17,2.43,.3,.36,.06,.72,.12,1.08,.19,.34,.07,.68,.14,1.03,.22,.36,.08,.71,.17,1.06,.27,13.84,3.7,24.03,16.33,24.03,31.34,0,17.91-14.52,32.44-32.44,32.44-14.61,0-26.96-9.66-31.02-22.93-.07-.24-.14-.49-.21-.73Z"
          />
          <path
            class="cls-566"
            d="M470.42,459.34c-.35-.09-.71-.18-1.06-.26-.34-.08-.68-.15-1.03-.22-.36-.07-.72-.13-1.08-.19-.9-.16-1.81-.27-2.73-.36-.86-.09-1.73-.14-2.61-.16-.34-.01-.68-.02-1.03-.02-3.96,0-7.79,.6-11.39,1.72-.49,.16-.99,.32-1.48,.5-.06,.02-.11,.04-.17,.06-.08,.03-.17,.06-.25,.09-.02,0-.04,.01-.06,.02h-.02s-.06,.03-.09,.04h-.02c-.32,.12-.63,.25-.95,.38-.25,.1-.5,.2-.75,.32-1.06,.45-2.1,.96-3.11,1.51h-.01s-.02,.01-.03,.02h-.01s-.05,.04-.09,.05c-.13,.07-.26,.14-.39,.21-.42,.24-.83,.48-1.24,.73-.17,.1-.33,.21-.5,.31-.04,.03-.07,.05-.11,.07-.21,.14-.42,.27-.63,.41l-.31,.21c-.61,.41-1.21,.85-1.79,1.31-.29,.21-.57,.44-.86,.68-7.29,5.97-12.34,14.58-13.68,24.37-.24,1.71-.36,3.46-.36,5.24,0,2.77,.29,5.48,.86,8.08,.05,.25,.11,.5,.17,.74,.1,.45,.21,.89,.34,1.34,.06,.25,.13,.49,.21,.73,4.69,15.82,19.33,27.36,36.67,27.36,21.13,0,38.26-17.13,38.26-38.25,0-17.83-12.2-32.82-28.72-37.05Zm-41.02,45.89c-.12-.44-.24-.88-.35-1.33-.06-.25-.11-.49-.16-.74-.46-2.18-.7-4.44-.7-6.76,0-10.14,4.62-19.21,11.87-25.2,.29-.24,.57-.47,.87-.7,.37-.29,.77-.58,1.16-.86,.29-.2,.58-.4,.88-.59,.01,0,.02-.01,.03-.02,.33-.22,.66-.43,1-.63,.07-.04,.14-.09,.21-.13,.23-.14,.46-.27,.69-.4,1.11-.63,2.25-1.18,3.43-1.67,.45-.19,.91-.37,1.37-.54,.04-.02,.07-.03,.11-.04,.32-.11,.63-.22,.95-.33h0s.02-.01,.03-.01c1.19-.39,2.41-.71,3.66-.96,2.08-.41,4.23-.63,6.43-.63,.94,0,1.86,.04,2.78,.12,.85,.07,1.69,.18,2.51,.31,.36,.06,.72,.12,1.07,.19,.34,.07,.68,.14,1.03,.22,.35,.08,.71,.17,1.06,.27,13.95,3.73,24.23,16.46,24.23,31.58,0,18.05-14.63,32.69-32.69,32.69-14.72,0-27.17-9.74-31.26-23.12-.07-.24-.14-.49-.21-.73Z"
          />
        </g>
        <g>
          <path
            class="cls-204"
            d="M470.63,464.6c-.21-.07-.43-.13-.65-.19-.18-.05-.36-.1-.54-.14-.04-.01-.08-.02-.11-.03-.32-.08-.63-.16-.95-.23h0c-.34-.08-.68-.16-1.02-.22-.36-.07-.72-.13-1.08-.19-.89-.15-1.78-.26-2.69-.33-.9-.07-1.8-.11-2.71-.11-2.23,0-4.4,.21-6.5,.64-1.31,.25-2.58,.59-3.82,1h0c-.38,.12-.75,.25-1.12,.39-.46,.17-.91,.34-1.36,.54-1.43,.59-2.8,1.28-4.12,2.07-.06,.03-.12,.07-.19,.11-.36,.21-.71,.44-1.06,.66,0,0-.02,.01-.02,.02-.3,.2-.6,.4-.9,.62-.38,.27-.75,.54-1.12,.83-.29,.22-.58,.45-.86,.68-4.3,3.53-7.69,8.12-9.79,13.38-.04,.1-.08,.19-.12,.29-.08,.2-.16,.4-.23,.6-1.3,3.56-2.02,7.41-2.02,11.43,0,2.37,.25,4.68,.72,6.9,.05,.25,.1,.5,.16,.74,.1,.45,.22,.89,.35,1.33,.06,.25,.13,.49,.21,.73,4.15,13.62,16.82,23.54,31.81,23.54,18.36,0,33.25-14.89,33.25-33.25,0-14.97-9.89-27.63-23.5-31.79Zm21.58,31.79c0,1.09-.05,2.17-.17,3.23-.02,.17-.03,.34-.05,.5-.12,.97-.28,1.93-.48,2.87-.03,.17-.07,.34-.11,.5-.34,1.44-.77,2.85-1.3,4.21-.06,.16-.12,.32-.19,.48-.74,1.85-1.66,3.6-2.73,5.24-.09,.14-.18,.28-.28,.42-.82,1.23-1.72,2.39-2.71,3.48-.11,.13-.22,.25-.34,.37-.65,.71-1.35,1.39-2.07,2.04-.13,.11-.25,.22-.38,.34-1.11,.96-2.29,1.85-3.53,2.64-.14,.1-.28,.19-.43,.27-1.66,1.04-3.43,1.93-5.29,2.64-.16,.06-.31,.12-.47,.18-1.37,.5-2.78,.91-4.24,1.23-.17,.04-.33,.07-.5,.1-.95,.19-1.9,.33-2.88,.43-.17,.02-.34,.03-.5,.05-.89,.07-1.78,.11-2.69,.11-.58,0-1.15-.02-1.72-.05-.17,0-.34-.02-.51-.03-2-.14-3.95-.47-5.83-.97-.16-.04-.33-.09-.49-.13-1.43-.4-2.81-.9-4.15-1.5-.16-.07-.31-.14-.47-.21-.88-.4-1.74-.85-2.58-1.34-.14-.09-.29-.17-.43-.26-1.26-.76-2.47-1.61-3.61-2.54-.13-.11-.26-.21-.39-.33-1.51-1.27-2.9-2.68-4.15-4.22-.11-.13-.21-.27-.32-.4-.91-1.16-1.74-2.37-2.48-3.65-.09-.14-.17-.29-.25-.44-.48-.85-.91-1.71-1.3-2.6-.07-.16-.14-.31-.2-.47-.41-.96-.77-1.95-1.08-2.96-.07-.24-.14-.48-.21-.73-.05-.16-.1-.33-.13-.49-.05-.17-.09-.33-.12-.49-.04-.12-.06-.24-.09-.36-.06-.25-.11-.49-.17-.74-.33-1.55-.54-3.13-.62-4.75-.01-.17-.02-.34-.03-.5-.02-.4-.02-.79-.02-1.19,0-1.09,.05-2.16,.17-3.22,.02-.17,.03-.34,.06-.5,.11-.97,.27-1.93,.47-2.87,.03-.17,.07-.33,.11-.5,.33-1.44,.77-2.86,1.29-4.22,.06-.16,.12-.32,.19-.47,.75-1.85,1.66-3.6,2.73-5.25,.09-.14,.18-.28,.28-.42,.82-1.23,1.73-2.39,2.71-3.48,.11-.13,.22-.25,.34-.37,.65-.71,1.35-1.4,2.07-2.04,.13-.11,.25-.22,.38-.33,.06-.06,.13-.11,.2-.17,.3-.26,.6-.51,.92-.76,.44-.35,.89-.68,1.36-1.01,.25-.18,.5-.35,.77-.52,.05-.03,.09-.06,.14-.09,.05-.03,.1-.06,.15-.1,.14-.1,.28-.19,.42-.27,.08-.06,.17-.11,.25-.16,.1-.05,.19-.11,.28-.17,.2-.12,.41-.24,.62-.36,1.13-.64,2.3-1.21,3.5-1.7,.21-.09,.43-.18,.65-.26,.16-.06,.31-.12,.47-.17,.09-.03,.17-.06,.26-.1,.01,0,.02,0,.03-.01,.32-.12,.65-.23,.97-.33,.01,0,.02,0,.02,0,.96-.3,1.95-.57,2.96-.79,.03,0,.05-.01,.08-.02,.14-.03,.28-.06,.42-.08,.94-.19,1.9-.33,2.87-.43,.17-.02,.34-.03,.5-.04,.88-.08,1.78-.12,2.69-.12,.58,0,1.16,.02,1.73,.05,.17,0,.33,.02,.5,.03,.24,.02,.48,.04,.71,.06,.7,.06,1.4,.16,2.09,.27,.36,.06,.72,.12,1.08,.19,.34,.07,.68,.14,1.02,.22,.32,.07,.63,.15,.94,.24,.04,.01,.08,.02,.12,.03,.12,.03,.25,.06,.36,.1,1.43,.4,2.81,.9,4.15,1.5,.16,.07,.31,.14,.47,.21,.88,.41,1.74,.86,2.58,1.34,.14,.09,.29,.18,.43,.26,1.26,.77,2.47,1.62,3.61,2.54,.13,.11,.26,.21,.39,.32,1.51,1.27,2.89,2.69,4.14,4.22,.11,.13,.21,.27,.32,.4,.92,1.16,1.74,2.37,2.48,3.64,.09,.15,.17,.29,.25,.44,.48,.85,.91,1.71,1.3,2.6,.07,.16,.13,.3,.2,.46,.57,1.35,1.05,2.74,1.43,4.18,.04,.16,.09,.33,.12,.49,.47,1.88,.77,3.84,.87,5.85,0,.17,.02,.33,.02,.5,.02,.39,.02,.78,.02,1.18Z"
          />
          <path
            class="cls-717"
            d="M469.51,463.92c-.35-.09-.71-.18-1.06-.26-.34-.08-.68-.16-1.03-.22-.35-.07-.71-.13-1.07-.19-.92-.16-1.86-.27-2.8-.34-.88-.07-1.78-.11-2.67-.11-2.25,0-4.45,.22-6.58,.65-1.3,.25-2.57,.59-3.82,1-.02,0-.04,.01-.06,.02-.39,.13-.77,.26-1.14,.4-.04,.02-.09,.03-.13,.05h-.02l-.04,.02c-.4,.14-.79,.3-1.18,.47-1.06,.44-2.1,.95-3.1,1.49h-.02s-.02,.02-.02,.02c-.33,.19-.66,.37-.98,.56-.06,.04-.11,.07-.17,.1-.36,.22-.72,.44-1.07,.67-.02,.01-.04,.03-.05,.04-.3,.19-.6,.4-.9,.61-.37,.26-.75,.54-1.11,.82-.29,.22-.58,.45-.86,.68-7.52,6.16-12.32,15.52-12.32,26,0,2.4,.25,4.73,.73,6.98,.05,.25,.11,.49,.17,.74,.1,.45,.21,.89,.34,1.34,.06,.25,.13,.49,.21,.73,2.63,8.66,8.66,15.83,16.54,19.96,.18,.1,.37,.19,.56,.29,.22,.11,.44,.22,.67,.33,.1,.05,.2,.1,.3,.14,.1,.05,.2,.1,.3,.14,4.21,1.9,8.87,2.95,13.78,2.95,15.7,0,28.88-10.77,32.57-25.31,.06-.23,.11-.46,.17-.7,.04-.16,.08-.32,.11-.48,.02-.07,.03-.14,.05-.22,.02-.12,.05-.25,.07-.37,.03-.12,.05-.25,.07-.37h0c.37-2,.57-4.05,.57-6.15,0-15.57-10.59-28.66-24.96-32.47Zm22.69,32.47c0,1.09-.05,2.17-.17,3.23-.02,.17-.03,.34-.05,.5-.12,.97-.28,1.93-.48,2.87-.03,.17-.07,.34-.11,.5-.34,1.44-.77,2.85-1.3,4.21-.06,.16-.12,.32-.19,.48-.74,1.85-1.66,3.6-2.73,5.24-.09,.14-.18,.28-.28,.42-.82,1.23-1.72,2.39-2.71,3.48-.11,.13-.22,.25-.34,.37-.65,.71-1.35,1.39-2.07,2.04-.13,.11-.25,.22-.38,.34-1.11,.96-2.29,1.85-3.53,2.64-.14,.1-.28,.19-.43,.27-1.66,1.04-3.43,1.93-5.29,2.64-.16,.06-.31,.12-.47,.18-1.37,.5-2.78,.91-4.24,1.23-.17,.04-.33,.07-.5,.1-.95,.19-1.9,.33-2.88,.43-.17,.02-.34,.03-.5,.05-.89,.07-1.78,.11-2.69,.11-.58,0-1.15-.02-1.72-.05-.17,0-.34-.02-.51-.03-2-.14-3.95-.47-5.83-.97-.16-.04-.33-.09-.49-.13-1.43-.4-2.81-.9-4.15-1.5-.16-.07-.31-.14-.47-.21-.88-.4-1.74-.85-2.58-1.34-.14-.09-.29-.17-.43-.26-1.26-.76-2.47-1.61-3.61-2.54-.13-.11-.26-.21-.39-.33-1.51-1.27-2.9-2.68-4.15-4.22-.11-.13-.21-.27-.32-.4-.91-1.16-1.74-2.37-2.48-3.65-.09-.14-.17-.29-.25-.44-.48-.85-.91-1.71-1.3-2.6-.07-.16-.14-.31-.2-.47-.41-.96-.77-1.95-1.08-2.96-.07-.24-.14-.48-.21-.73-.05-.16-.1-.33-.13-.49-.05-.17-.09-.33-.12-.49-.04-.12-.06-.24-.09-.36-.06-.25-.11-.49-.17-.74-.33-1.55-.54-3.13-.62-4.75-.01-.17-.02-.34-.03-.5-.02-.4-.02-.79-.02-1.19,0-1.09,.05-2.16,.17-3.22,.02-.17,.03-.34,.06-.5,.11-.97,.27-1.93,.47-2.87,.03-.17,.07-.33,.11-.5,.33-1.44,.77-2.86,1.29-4.22,.06-.16,.12-.32,.19-.47,.75-1.85,1.66-3.6,2.73-5.25,.09-.14,.18-.28,.28-.42,.82-1.23,1.73-2.39,2.71-3.48,.11-.13,.22-.25,.34-.37,.65-.71,1.35-1.4,2.07-2.04,.13-.11,.25-.22,.38-.33,.06-.06,.13-.11,.2-.17,.3-.26,.6-.51,.92-.76,.44-.35,.89-.68,1.36-1.01,.25-.18,.5-.35,.77-.52,.05-.03,.09-.06,.14-.09,.05-.03,.1-.06,.15-.1,.14-.1,.28-.19,.42-.27,.08-.06,.17-.11,.25-.16,.1-.05,.19-.11,.28-.17,.2-.12,.41-.24,.62-.36,1.13-.64,2.3-1.21,3.5-1.7,.21-.09,.43-.18,.65-.26,.16-.06,.31-.12,.47-.17,.09-.03,.17-.06,.26-.1,.01,0,.02,0,.03-.01,.32-.12,.65-.23,.97-.33,.01,0,.02,0,.02,0,.96-.3,1.95-.57,2.96-.79,.03,0,.05-.01,.08-.02,.14-.03,.28-.06,.42-.08,.94-.19,1.9-.33,2.87-.43,.17-.02,.34-.03,.5-.04,.88-.08,1.78-.12,2.69-.12,.58,0,1.16,.02,1.73,.05,.17,0,.33,.02,.5,.03,.24,.02,.48,.04,.71,.06,.7,.06,1.4,.16,2.09,.27,.36,.06,.72,.12,1.08,.19,.34,.07,.68,.14,1.02,.22,.32,.07,.63,.15,.94,.24,.04,.01,.08,.02,.12,.03,.12,.03,.25,.06,.36,.1,1.43,.4,2.81,.9,4.15,1.5,.16,.07,.31,.14,.47,.21,.88,.41,1.74,.86,2.58,1.34,.14,.09,.29,.18,.43,.26,1.26,.77,2.47,1.62,3.61,2.54,.13,.11,.26,.21,.39,.32,1.51,1.27,2.89,2.69,4.14,4.22,.11,.13,.21,.27,.32,.4,.92,1.16,1.74,2.37,2.48,3.64,.09,.15,.17,.29,.25,.44,.48,.85,.91,1.71,1.3,2.6,.07,.16,.13,.3,.2,.46,.57,1.35,1.05,2.74,1.43,4.18,.04,.16,.09,.33,.12,.49,.47,1.88,.77,3.84,.87,5.85,0,.17,.02,.33,.02,.5,.02,.39,.02,.78,.02,1.18Z"
          />
          <g class="cls-738">
            <path
              class="cls-253"
              d="M491.6,481.61c-.09-.17-.17-.34-.25-.51-4.38-8.56-12.27-15.02-21.78-17.48-.35-.09-.71-.18-1.06-.26-.34-.07-.68-.14-1.03-.21-.35-.07-.71-.13-1.07-.19-.95-.16-1.92-.27-2.89-.34-.83-.06-1.67-.1-2.53-.1-2.32,0-4.57,.23-6.76,.67-1.28,.26-2.54,.59-3.76,1-.05,.01-.11,.03-.16,.05-.16,.04-.3,.1-.45,.16-.14,.04-.28,.09-.42,.14-.1,.03-.19,.07-.28,.1-.46,.17-.92,.35-1.37,.55-1.19,.5-2.35,1.07-3.47,1.7-.13,.07-.26,.14-.38,.21-.09,.05-.18,.1-.26,.16-.05,.03-.11,.06-.16,.09-.37,.21-.73,.44-1.09,.68-.02,.02-.05,.03-.07,.05-.31,.2-.61,.4-.9,.61-.37,.26-.75,.54-1.11,.82-.29,.22-.58,.44-.86,.67-7.67,6.25-12.57,15.77-12.57,26.44,0,2.34,.24,4.64,.7,6.85,.05,.25,.1,.49,.16,.74,.1,.45,.21,.9,.33,1.34,.07,.25,.14,.49,.21,.73,.57,1.95,1.32,3.83,2.22,5.62,.01,.01,.01,.03,.02,.04,5.61,11.13,17.14,18.76,30.45,18.76,18.83,0,34.08-15.26,34.08-34.08,0-5.39-1.25-10.48-3.47-15.01Zm-30.61,48.44c-4.95,0-9.66-1.08-13.89-3.01-.1-.05-.2-.1-.3-.14-.1-.04-.2-.1-.3-.14-.22-.11-.45-.22-.67-.33-.19-.1-.37-.19-.56-.29-6.07-3.24-11.03-8.3-14.14-14.45-.1-.19-.19-.37-.28-.57-.77-1.59-1.41-3.26-1.92-4.99-.07-.24-.14-.48-.2-.73-.12-.44-.24-.89-.34-1.34-.06-.25-.11-.49-.16-.74-.44-2.17-.67-4.4-.67-6.7,0-4.1,.74-8.03,2.09-11.66,.07-.2,.15-.4,.23-.6,.04-.1,.08-.19,.12-.29,2.11-5.23,5.52-9.81,9.82-13.33,.28-.24,.57-.46,.86-.68,.37-.29,.74-.56,1.12-.83,.3-.21,.6-.42,.91-.62,0,0,.01,0,.02-.01,.35-.22,.7-.45,1.05-.66,.06-.04,.12-.07,.19-.11,1.32-.79,2.69-1.48,4.12-2.07,.45-.19,.91-.37,1.37-.54,.36-.13,.73-.26,1.11-.39h.02c1.24-.41,2.51-.74,3.8-1,2.13-.43,4.34-.66,6.6-.66,.88,0,1.74,.03,2.6,.1,.91,.07,1.8,.18,2.69,.32,.36,.05,.72,.12,1.08,.19,.35,.06,.69,.14,1.03,.21,.32,.07,.64,.15,.95,.23,.04,.01,.07,.02,.11,.03,.18,.05,.36,.09,.54,.14,.21,.06,.43,.12,.65,.19,8.48,2.55,15.54,8.36,19.72,15.99,.14,.25,.27,.49,.4,.74,.1,.18,.19,.37,.28,.57,2.18,4.44,3.41,9.44,3.41,14.73,0,2.02-.18,4-.52,5.91h0c-.02,.13-.04,.26-.07,.37-.02,.12-.05,.25-.07,.37-.01,.07-.03,.14-.04,.22-.03,.16-.07,.32-.11,.48-.05,.24-.11,.47-.17,.7-3.6,14.58-16.77,25.38-32.46,25.38Z"
            />
          </g>
          <path
            class="cls-485"
            d="M491.6,481.61c-.09-.17-.17-.34-.25-.51-4.33-8.63-12.22-15.15-21.75-17.67-.35-.1-.7-.18-1.06-.27-.34-.07-.68-.15-1.03-.21-.35-.07-.71-.13-1.08-.19-.97-.17-1.96-.28-2.95-.36-.86-.06-1.73-.1-2.61-.1-2.31,0-4.56,.22-6.74,.66-1.25,.25-2.47,.57-3.67,.95-.09,.03-.18,.05-.27,.09-.16,.05-.31,.1-.45,.16-.14,.04-.28,.09-.42,.14-.1,.04-.2,.07-.29,.11-.46,.17-.92,.35-1.37,.54-1.19,.5-2.35,1.06-3.46,1.69-.13,.07-.26,.14-.39,.22-.09,.05-.18,.11-.27,.16-.05,.03-.1,.06-.14,.09-.37,.22-.74,.45-1.1,.69-.03,.02-.06,.04-.09,.06-.3,.2-.6,.4-.9,.62-.38,.26-.75,.54-1.12,.82-.29,.22-.58,.45-.86,.67-7.66,6.25-12.54,15.77-12.54,26.42,0,2.43,.26,4.81,.75,7.1,.05,.25,.11,.49,.17,.74,.1,.45,.21,.89,.34,1.34,.07,.24,.14,.49,.21,.73,.59,1.95,1.35,3.83,2.26,5.61,.01,.01,.01,.03,.02,.04,5.65,11,17.12,18.53,30.34,18.53,18.82,0,34.08-15.26,34.08-34.08,0-5.3-1.21-10.31-3.36-14.78Zm-30.72,48.21c-12.96,0-24.2-7.37-29.74-18.14-.1-.19-.19-.37-.28-.57-.78-1.59-1.44-3.25-1.96-4.98-.07-.24-.14-.48-.21-.73-.13-.44-.24-.89-.35-1.34-.06-.25-.11-.49-.16-.74-.48-2.24-.73-4.56-.73-6.95,0-10.42,4.77-19.74,12.25-25.87,.28-.24,.57-.46,.86-.68,.36-.28,.74-.56,1.12-.82,.3-.21,.6-.41,.9-.6,.01-.01,.03-.02,.04-.03,.35-.24,.7-.45,1.06-.67,.06-.04,.12-.07,.18-.1,1.32-.79,2.69-1.48,4.11-2.08,.45-.19,.9-.36,1.37-.54,.37-.14,.75-.27,1.14-.4,.01,0,.02,0,.03,0,1.25-.41,2.53-.75,3.83-1,2.11-.42,4.3-.65,6.54-.65,.9,0,1.8,.04,2.69,.11,.93,.07,1.85,.18,2.76,.33,.36,.06,.72,.13,1.08,.2,.34,.07,.68,.14,1.02,.22,.36,.08,.71,.17,1.06,.27,9.02,2.39,16.54,8.46,20.86,16.51,.14,.25,.27,.49,.4,.74,.1,.18,.19,.37,.28,.57,2.11,4.38,3.3,9.3,3.3,14.49,0,18.47-14.97,33.44-33.44,33.44Z"
          />
        </g>
      </g>
      <g>
        <path
          class="cls-561"
          d="M479.07,493.9s-.01-.09-.02-.13c0-.06-.02-.12-.03-.18,0-.04-.01-.09-.02-.13-.13-.81-.32-1.61-.56-2.38-.02-.1-.05-.2-.09-.29-.57-1.8-1.42-3.48-2.49-4.99-.05-.09-.12-.17-.18-.25-.48-.66-1.01-1.28-1.57-1.87-.03-.03-.06-.06-.1-.1-.04-.04-.07-.09-.12-.12-.03-.03-.06-.06-.09-.1-.58-.57-1.2-1.11-1.85-1.6-.08-.06-.16-.13-.25-.19-1.49-1.1-3.15-1.97-4.94-2.58-.08-.03-.17-.06-.25-.09-.01,0-.03-.01-.04-.01-.33-.11-.67-.21-1.02-.29-.34-.09-.68-.16-1.02-.23-.11-.02-.22-.04-.34-.06-.04,0-.09-.02-.13-.02-.05-.01-.11-.02-.17-.03-.04-.01-.09-.02-.13-.02-.1-.02-.21-.03-.31-.04-.7-.1-1.41-.16-2.13-.17-.1,0-.2,0-.31,0h-.07c-1.5,0-2.96,.18-4.36,.52-.36,.09-.72,.19-1.08,.3-.1,.03-.2,.06-.29,.09-.02,0-.04,.01-.06,.02-.76,.25-1.49,.55-2.2,.89-.04,.02-.08,.04-.12,.06-.05,.03-.1,.05-.16,.08-.04,.02-.08,.04-.12,.06-.54,.27-1.06,.58-1.57,.9-.18,.12-.36,.24-.53,.36-.09,.06-.17,.11-.25,.18-.14,.1-.28,.2-.42,.32-1.18,.9-2.25,1.95-3.18,3.12-.12,.16-.25,.32-.37,.48-.06,.08-.12,.16-.18,.25-.48,.66-.91,1.35-1.3,2.07-.02,.04-.04,.07-.06,.12-.03,.05-.06,.1-.08,.15-.02,.04-.04,.07-.06,.12-.37,.72-.69,1.48-.96,2.25-.04,.1-.07,.19-.1,.29-.57,1.73-.89,3.58-.91,5.5,0,.08,0,.17,0,.25v.06c0,.82,.06,1.64,.17,2.44,0,.04,.01,.09,.02,.13,0,.04,.01,.09,.02,.13,0,.01,0,.03,0,.04,0,.04,.02,.09,.02,.13,.02,.13,.04,.27,.07,.41,.05,.25,.1,.49,.16,.74,.09,.42,.2,.83,.32,1.24,.01,.03,.02,.06,.03,.1,.02,.06,.04,.13,.06,.19,.06,.18,.12,.35,.18,.53,.57,1.6,1.35,3.1,2.31,4.46,.06,.09,.12,.17,.18,.25,.48,.66,1.01,1.29,1.57,1.87,.03,.03,.06,.06,.09,.1,.04,.04,.08,.09,.12,.12,.03,.03,.05,.06,.09,.09,.57,.58,1.19,1.11,1.85,1.61,.08,.06,.16,.13,.25,.18,1.49,1.1,3.16,1.98,4.94,2.58,.1,.04,.19,.07,.29,.1,.77,.25,1.56,.45,2.38,.59,.04,.01,.09,.02,.13,.02,.05,.02,.11,.02,.17,.03,.04,0,.09,.02,.13,.02,.79,.13,1.61,.2,2.43,.21,.1,.01,.2,.01,.31,.01h.07c1.89,0,3.72-.29,5.44-.82,.1-.03,.19-.06,.29-.09,.78-.26,1.54-.57,2.27-.93,.04-.02,.08-.04,.12-.06,.05-.02,.1-.05,.16-.07,.04-.02,.07-.04,.12-.06,.73-.37,1.42-.8,2.09-1.26,.09-.05,.17-.11,.25-.18,1.52-1.09,2.86-2.41,3.98-3.91,.06-.08,.12-.17,.18-.25,.48-.66,.91-1.35,1.31-2.08,.02-.04,.04-.07,.06-.11,.03-.05,.05-.1,.08-.16,.02-.04,.04-.08,.06-.12,.37-.72,.69-1.48,.96-2.25,.03-.1,.06-.19,.1-.29,.57-1.73,.89-3.58,.91-5.5,0-.08,0-.17,0-.25v-.06c0-.83-.06-1.64-.17-2.44Zm-2.49,1.2c.12,.16,.13,.37,.05,.54-.04,.07-.09,.14-.17,.2-.03,.02-.05,.04-.08,.05-.22,.11-.5,.04-.66-.17,0,0,0,0-.01-.01-.06-.1-.09-.22-.08-.33,0-.01,0-.02,0-.03,.01-.14,.09-.27,.21-.36,.19-.14,.44-.13,.62,0,.04,.03,.08,.06,.11,.11Zm-31.16,4.5s-.03,.04-.04,.05c-.03,.04-.07,.07-.11,.11-.21,.16-.51,.12-.68-.06-.02-.02-.03-.03-.05-.05-.03-.04-.06-.09-.07-.14-.02-.05-.03-.11-.03-.17h0s0-.09,.02-.13c.03-.12,.1-.22,.2-.3,.24-.17,.57-.12,.74,.12,.02,.02,.03,.04,.04,.06,.04,.07,.06,.14,.06,.22,0,.1-.02,.2-.07,.29Zm-.43-4.83c-.27,.09-.57-.06-.66-.34-.09-.28,.06-.58,.34-.67,.27-.09,.57,.06,.66,.34,.09,.27-.06,.57-.34,.66Zm14.15-11.26c.62-.6,1.58-.75,2.35-.3,0,0,0,0,0,0,.09,.05,.17,.11,.25,.17,.21,.17,.38,.37,.5,.6,.19,.35,.27,.77,.22,1.17h0c-.03,.25-.11,.5-.25,.73-.02,.04-.04,.07-.08,.11-.11,.16-.24,.3-.38,.42-.06,.05-.13,.1-.2,.15-.2,.12-.42,.21-.65,.26-.22,.05-.46,.05-.7,.02-.1-.01-.19-.03-.29-.07-.13-.04-.26-.1-.39-.17-.23-.13-.43-.31-.58-.51-.47-.61-.55-1.46-.14-2.16,.09-.16,.2-.29,.32-.41Zm16.41,16.16c.27-.09,.58,.06,.66,.34,.09,.27-.06,.58-.34,.66-.28,.09-.58-.06-.67-.34-.09-.28,.06-.58,.34-.67Zm-12.62,9.19c-.54,.94-1.74,1.25-2.67,.72,0,0,0,0,0,0-.09-.05-.17-.11-.25-.17-.54-.44-.8-1.11-.72-1.78h0c.03-.25,.11-.5,.25-.73,.02-.04,.04-.07,.07-.11,.16-.24,.36-.43,.59-.57,.4-.25,.87-.35,1.34-.27,.1,.01,.19,.03,.29,.07,.13,.04,.26,.1,.39,.17,.23,.13,.43,.31,.58,.51,.47,.61,.55,1.47,.14,2.17Zm-10.37-7.72s.09,.1,.13,.16c.24,.32,.37,.72,.37,1.15,0,.27-.05,.53-.16,.77-.29,.7-1,1.2-1.8,1.2-.1,0-.19,0-.28-.02-.11-.01-.21-.04-.31-.07-.8-.25-1.38-1-1.38-1.87,0-.57,.25-1.09,.64-1.44,.35-.32,.81-.51,1.32-.51,.04,0,.09,0,.12,0,.13,0,.25,.03,.37,.06h0c.37,.1,.71,.3,.96,.59Zm-3.75-.98c-.17-.07-.33-.16-.47-.27-.13-.1-.24-.21-.33-.33-.07-.09-.13-.19-.19-.29,0-.01-.01-.02-.02-.03-.05-.09-.09-.18-.11-.27-.05-.13-.09-.27-.1-.42-.03-.24-.02-.49,.05-.74,.02-.07,.04-.14,.07-.21,.01-.02,.02-.05,.03-.07,.1-.24,.25-.44,.43-.61,.03-.03,.06-.05,.09-.07,.3-.26,.68-.42,1.08-.45,.3-.03,.62,.01,.92,.13,.04,.02,.08,.03,.12,.05,.2,.1,.39,.22,.53,.38,.07,.07,.14,.14,.2,.22,.04,.05,.07,.1,.1,.15,.05,.09,.1,.19,.14,.29,.1,.24,.14,.49,.14,.74,0,.05,0,.1-.01,.16-.01,.1-.03,.2-.05,.29-.02,.09-.05,.17-.08,.26,0,0,0,0,0,.01-.1,.25-.25,.46-.42,.63-.04,.04-.09,.09-.14,.13-.09,.07-.18,.13-.27,.19-.04,.03-.09,.05-.13,.07-.29,.14-.61,.21-.94,.19-.21,0-.43-.05-.64-.13Zm24.93-6.95c.07,.1,.14,.2,.2,.32,.05,.09,.09,.18,.12,.28,.13,.36,.14,.77,.04,1.16-.02,.07-.04,.13-.07,.2-.01,.03-.02,.05-.04,.07-.12,.27-.3,.5-.52,.68-.3,.26-.68,.42-1.08,.45-.31,.03-.62-.01-.93-.13-.04-.02-.07-.03-.11-.05-.2-.1-.39-.22-.53-.38-.08-.07-.14-.14-.2-.22-.28-.38-.42-.86-.37-1.34,0-.1,.03-.2,.05-.29,.02-.09,.05-.17,.08-.26,.1-.25,.25-.47,.43-.65,.04-.04,.09-.09,.14-.12,.12-.11,.25-.19,.4-.26,.48-.24,1.05-.27,1.58-.06,.17,.07,.33,.16,.46,.27,.13,.1,.24,.21,.34,.33Zm-3.09-.93s-.09,0-.12,0c-.53-.03-1-.28-1.33-.65-.05-.05-.09-.1-.13-.16-.24-.32-.37-.72-.37-1.15,0-.27,.05-.53,.16-.76,.29-.7,.99-1.2,1.8-1.2,.1,0,.19,0,.28,.02,.11,.01,.2,.04,.31,.07,.8,.25,1.38,1,1.38,1.87,0,1.08-.88,1.96-1.96,1.96Zm-17.4-6.68s.09-.01,.13-.02c.1,0,.2,0,.3,0,.11,0,.21,.02,.31,.05,.75,.19,1.35,.81,1.47,1.63,0,.04,.01,.08,.02,.12,.04,.51-.12,.99-.42,1.36-.09,.12-.2,.23-.32,.32-.04,.03-.08,.06-.12,.09-.24,.16-.52,.27-.83,.32-.09,.01-.18,.02-.26,.02-.18,0-.35-.02-.51-.06-.64-.17-1.16-.66-1.36-1.3-.03-.1-.06-.21-.08-.32-.09-.59,.11-1.17,.49-1.58,.29-.33,.71-.56,1.18-.63Zm-1.31,3.8c.14,.11,.27,.24,.38,.39,.05,.05,.09,.11,.12,.17,.02,.04,.04,.07,.05,.11,.15,.3,.22,.62,.2,.94v.05c0,.08-.02,.16-.03,.24h0c-.09,.47-.34,.89-.73,1.18-.07,.05-.14,.11-.22,.15-.01,0-.02,.01-.03,.02-.22,.13-.47,.2-.71,.24-.27,.03-.54,.01-.79-.06-.32-.09-.6-.26-.84-.49-.12-.12-.22-.26-.32-.41-.04-.08-.09-.16-.12-.24-.09-.21-.13-.44-.14-.66,0-.1,0-.2,.01-.29,.04-.39,.2-.77,.47-1.06,.06-.07,.13-.15,.21-.21,.09-.08,.19-.15,.29-.21,.02-.01,.05-.03,.07-.04,.17-.09,.34-.15,.52-.18,.56-.12,1.14,.02,1.59,.37Zm16.56,17.75c-.15,.02-.29,.03-.43,.01-.11,0-.21-.02-.31-.05-.75-.19-1.35-.82-1.47-1.63,0-.04-.01-.08-.02-.12-.05-.67,.24-1.29,.74-1.69,.04-.03,.08-.06,.12-.09,0,0,0,0,0,0,.24-.16,.52-.27,.82-.31,.27-.04,.53-.02,.78,.04,.74,.2,1.33,.82,1.44,1.62,.15,1.07-.6,2.07-1.67,2.22Zm1.31-3.8c-.14-.11-.27-.24-.38-.39-.05-.05-.09-.11-.12-.17-.02-.04-.04-.07-.05-.11-.15-.3-.21-.62-.2-.94,0-.1,.01-.19,.03-.29,.08-.46,.33-.89,.72-1.19,.07-.05,.14-.11,.22-.15,.01,0,.02-.01,.03-.02,.22-.12,.47-.2,.71-.23,.26-.03,.52-.01,.78,.06,.48,.13,.9,.44,1.17,.9,.05,.08,.09,.17,.12,.25,.09,.21,.13,.43,.13,.65,0,.1,0,.2-.01,.29-.04,.39-.2,.77-.47,1.06-.06,.07-.13,.15-.21,.21-.09,.08-.18,.15-.28,.21-.02,.01-.05,.03-.07,.04-.17,.09-.34,.15-.52,.18-.56,.12-1.14-.02-1.59-.37Zm4.86-12.94c.17-.24,.5-.29,.74-.12,.24,.18,.28,.5,.12,.74-.18,.24-.5,.29-.74,.12-.24-.17-.29-.5-.12-.73Zm.86-1.44c-.17,.24-.5,.29-.73,.12-.24-.17-.29-.5-.12-.74,.18-.23,.5-.28,.74-.11,.24,.17,.29,.5,.12,.73Zm-9.48-1.84s-.06,.05-.1,.07c-.32,.22-.68,.33-1.04,.34h-.08c-.07,0-.15,0-.22-.02-.3-.03-.58-.14-.83-.3-.11-.07-.22-.16-.32-.26-.05-.05-.1-.11-.15-.17-.17-.21-.28-.45-.35-.7,0-.03-.02-.05-.02-.07-.08-.34-.06-.68,.04-1.01,.04-.15,.1-.29,.18-.42,.03-.05,.06-.1,.09-.14,.11-.16,.24-.29,.39-.41,.2-.16,.42-.26,.64-.33,.06-.02,.13-.04,.19-.05,.03-.01,.06-.02,.1-.02,.34-.05,.68-.01,1,.12,.31,.12,.59,.33,.81,.61,.67,.86,.52,2.09-.34,2.75Zm-20.17,4.96c.28-.09,.58,.06,.67,.34,.09,.28-.06,.57-.34,.67-.27,.09-.58-.06-.66-.34-.09-.28,.06-.58,.34-.66Zm9.82,13.53s.06-.05,.1-.07c.32-.22,.68-.34,1.05-.35,.1,0,.2,0,.3,.02,.42,.05,.83,.25,1.14,.57,.05,.05,.11,.11,.16,.17,.17,.21,.28,.45,.35,.7,.1,.36,.09,.74-.02,1.09-.04,.14-.1,.28-.18,.41-.02,.04-.04,.08-.08,.12-.1,.16-.24,.3-.4,.43-.2,.16-.42,.26-.64,.33-.1,.03-.19,.05-.29,.06-.67,.1-1.37-.16-1.82-.73-.66-.86-.51-2.09,.34-2.75Zm14.45,2.37c.09-.27,.39-.43,.67-.34,.27,.09,.43,.39,.34,.66-.09,.28-.39,.43-.67,.34-.28-.09-.43-.39-.34-.66Zm6.27-9.33c-.09-.27,.06-.58,.34-.66,.27-.09,.57,.06,.66,.34,.09,.28-.06,.58-.34,.67-.28,.09-.57-.06-.66-.34Zm.88-5.09c-.03,.12-.09,.22-.19,.29-.24,.17-.57,.12-.74-.12-.06-.09-.1-.18-.1-.28,0-.1,.02-.2,.07-.29,.03-.06,.09-.12,.14-.16,.24-.17,.56-.12,.73,.11,.03,.04,.06,.09,.07,.14,.04,.1,.04,.2,.01,.3Zm-.18-2.51c.21-.16,.51-.13,.69,.06,.02,.02,.03,.03,.05,.05,.05,.06,.07,.13,.09,.21,.04,.19-.04,.41-.21,.53-.19,.14-.45,.13-.63-.01-.04-.03-.07-.06-.11-.11-.03-.04-.05-.09-.07-.13-.08-.21,0-.47,.18-.6Zm-1.7-4.88c.24,.17,.29,.5,.12,.74-.17,.23-.5,.29-.74,.11-.24-.17-.28-.5-.12-.73,.02-.03,.05-.06,.07-.08,.1-.09,.22-.14,.36-.14h0c.1,0,.21,.03,.3,.1Zm-2.6-.07c.19,.06,.32,.22,.35,.41,.02,.08,.01,.17-.02,.26l-.03,.08c-.12,.22-.39,.34-.64,.26,0,0-.01,0-.02,0-.11-.04-.2-.12-.26-.21-.01-.01-.02-.02-.02-.03-.07-.12-.09-.27-.04-.42,.07-.22,.29-.37,.51-.36,.05,0,.11,0,.16,.03Zm-.64-1.96c.05,.02,.1,.04,.14,.07,.09,.05,.15,.14,.18,.23,.04,.11,.05,.24,.01,.36-.09,.28-.39,.43-.66,.34-.11-.04-.19-.1-.25-.18-.06-.08-.1-.17-.11-.27-.01-.07,0-.14,.02-.21,.09-.28,.39-.43,.66-.34Zm-1.29-1.62c.08-.25,.34-.4,.59-.36,.02,.01,.05,.02,.07,.02,.07,.03,.14,.06,.19,.12,.15,.13,.21,.34,.15,.55-.07,.23-.29,.37-.52,.36-.05,0-.1-.01-.15-.03-.05-.02-.1-.04-.13-.07-.19-.12-.28-.36-.2-.59Zm-1.83,.39c.29,0,.53,.24,.53,.52s-.24,.53-.53,.53-.53-.24-.53-.53,.24-.52,.53-.52Zm-1.21-1.67c.29,0,.53,.24,.53,.53s-.24,.52-.53,.52-.52-.24-.52-.52,.24-.53,.52-.53Zm-.68-1.14c0,.29-.23,.53-.52,.53-.17,0-.32-.07-.41-.2-.07-.09-.12-.2-.12-.33,0-.04,0-.07,.02-.11,.02-.13,.1-.24,.2-.3,.02-.02,.04-.03,.06-.04,.08-.04,.17-.07,.26-.07,.29,0,.52,.24,.52,.52Zm-2.67,.94c.17-.06,.35-.02,.48,.08,.02,.01,.03,.03,.04,.04,.06,.06,.11,.13,.13,.22,.01,.03,.02,.06,.02,.09,.04,.25-.11,.5-.36,.58,0,0-.01,0-.02,0h0c-.11,.03-.23,.02-.33-.02-.01,0-.02,0-.03-.01-.13-.06-.23-.17-.28-.32-.07-.22,.02-.46,.2-.59,.04-.03,.09-.05,.14-.07Zm-1.66-1.21c.05-.02,.11-.03,.16-.03,.02,0,.04,0,.06,0,.08,0,.16,.03,.22,.07,.1,.06,.18,.16,.22,.28,.09,.28-.06,.57-.34,.66-.1,.03-.2,.03-.3,0-.1-.02-.19-.07-.25-.16-.05-.05-.09-.11-.11-.19-.09-.28,.06-.58,.34-.66Zm-1.73-1.19s.05-.02,.07-.03c.08-.03,.15-.03,.22-.02,.2,.02,.37,.16,.44,.36,.07,.23-.01,.47-.2,.6-.04,.03-.09,.05-.13,.07-.05,.02-.1,.02-.14,.02-.23,.01-.44-.13-.52-.36-.09-.25,.04-.52,.27-.64Zm-1.52,2.03c.24-.18,.57-.12,.74,.11,.17,.24,.12,.57-.12,.74-.23,.17-.56,.12-.73-.12-.17-.24-.12-.57,.11-.73Zm-1.95-.65c.24-.17,.57-.12,.74,.12,.17,.24,.12,.56-.12,.74-.13,.09-.29,.12-.44,.08-.12-.03-.22-.09-.29-.2-.11-.15-.13-.33-.07-.49,.03-.1,.09-.19,.18-.26Zm-1.96-.64c.24-.17,.57-.12,.74,.12,.17,.24,.12,.57-.12,.74-.14,.11-.33,.13-.49,.06-.1-.03-.18-.09-.25-.18-.02-.03-.04-.06-.05-.1-.05-.11-.06-.23-.03-.34,0-.01,0-.02,.01-.03,.03-.1,.09-.2,.18-.27Zm-.87,2.45c.12-.17,.31-.24,.5-.21,.09,.01,.17,.04,.24,.1,.03,.02,.05,.04,.07,.06,.18,.18,.2,.46,.05,.67,0,0,0,.01-.01,.01-.07,.1-.17,.16-.28,.18-.01,0-.02,.01-.03,.01-.13,.03-.28,0-.41-.09-.19-.14-.27-.39-.19-.6,.01-.05,.04-.09,.07-.13Zm-1.66-.22c.12-.01,.24,.02,.34,.1,.24,.17,.28,.49,.12,.73-.06,.09-.14,.15-.24,.18-.1,.04-.2,.04-.3,.02-.07-.02-.14-.04-.2-.09-.24-.17-.29-.5-.11-.74,.03-.04,.07-.08,.11-.11,.08-.07,.18-.11,.28-.11Zm-2.46,.21c.05-.06,.11-.11,.17-.14,.14-.08,.3-.1,.45-.03,.04,.01,.07,.03,.11,.06,.18,.12,.25,.34,.2,.54,0,.02,0,.04-.02,.06-.02,.05-.04,.09-.07,.13-.03,.04-.06,.08-.1,.11-.18,.14-.44,.15-.63,.01-.22-.16-.28-.45-.16-.68,.01-.02,.02-.04,.04-.06Zm.59,2.26c.28,.09,.43,.39,.34,.66-.04,.11-.1,.19-.18,.25-.13,.1-.31,.14-.48,.09-.27-.09-.43-.39-.34-.66,.06-.17,.19-.29,.34-.34,.1-.03,.21-.04,.33,0Zm-2.62,.97c.09-.28,.39-.43,.66-.34,.28,.09,.43,.39,.34,.66-.09,.28-.39,.43-.66,.34-.28-.1-.43-.39-.34-.67Zm-1.96,.64c.09-.28,.39-.43,.67-.34,.27,.09,.43,.39,.34,.66-.09,.28-.39,.43-.67,.34-.03-.01-.06-.03-.1-.04-.12-.06-.2-.17-.24-.29-.03-.1-.04-.21,0-.32Zm.73,2.49c0-.2,.11-.38,.28-.47,.07-.04,.16-.06,.25-.06,.03,0,.06,0,.09,.01,.25,.04,.44,.25,.44,.52v.02c0,.12-.05,.23-.12,.32,0,.01-.01,.02-.02,.03-.1,.1-.23,.17-.38,.17-.24,0-.44-.16-.5-.37-.02-.05-.03-.1-.03-.15Zm-1.47,.8c.09-.08,.2-.12,.33-.12,.29,0,.53,.24,.53,.52,0,.11-.03,.2-.09,.29h0c-.05,.09-.13,.15-.22,.19h0c-.06,.03-.13,.04-.21,.04-.29,0-.52-.24-.52-.52,0-.05,.01-.11,.03-.16,.03-.1,.09-.19,.17-.25Zm-1.86,1.61c0-.07,.02-.15,.05-.21,.08-.18,.26-.31,.48-.31,.24,0,.44,.16,.5,.38,.02,.05,.02,.1,.02,.14,0,.05,0,.1-.03,.15-.06,.22-.26,.38-.5,.38-.27,0-.48-.2-.52-.45,0-.02,0-.05,0-.07Zm-.96,5.48c-.09-.28,.06-.58,.34-.67,.28-.09,.57,.06,.66,.34,.09,.28-.06,.58-.34,.67-.03,0-.05,.02-.08,.02h0c-.14,.02-.28-.02-.39-.1-.09-.06-.15-.15-.19-.26Zm2.05,1.59c-.12-.16-.13-.37-.05-.54,.04-.07,.09-.14,.17-.2,.03-.02,.05-.04,.09-.05,.22-.11,.5-.04,.65,.17,0,0,0,0,0,.01,.07,.1,.1,.22,.09,.33,0,.01,0,.02,0,.03-.01,.14-.09,.27-.21,.36-.19,.14-.44,.13-.62,0-.04-.03-.08-.06-.11-.11Zm-1.16,3.17c.19-.14,.44-.13,.63,.01,.04,.03,.07,.06,.11,.11,.03,.04,.05,.09,.07,.13,.04,.11,.04,.22,0,.33-.03,.11-.09,.2-.19,.27-.22,.16-.51,.13-.69-.06-.02-.02-.03-.03-.05-.05-.05-.06-.08-.13-.09-.21-.04-.19,.04-.41,.21-.53Zm2.21,.88c.17-.24,.5-.29,.74-.12,.02,.02,.04,.04,.06,.06,.18,.18,.21,.47,.05,.67-.17,.24-.49,.29-.73,.12-.19-.14-.26-.37-.19-.58,.01-.05,.04-.11,.07-.16Zm.85,2.68c-.17,.24-.5,.29-.74,.12-.24-.17-.28-.5-.11-.73,.17-.24,.5-.29,.73-.12,.24,.18,.29,.5,.12,.74Zm-.74,2.18c-.24-.17-.29-.5-.12-.74,.17-.24,.5-.29,.73-.11,.24,.17,.29,.49,.12,.73-.02,.03-.05,.06-.07,.08-.1,.09-.22,.13-.35,.13h0c-.11,0-.22-.03-.31-.1Zm2.6,.07c-.19-.06-.32-.22-.35-.41-.02-.08-.01-.17,.02-.26,.01-.03,.02-.05,.03-.08,.12-.22,.39-.34,.63-.26,0,0,.01,0,.02,0,.12,.04,.21,.12,.27,.21,.01,.01,.02,.02,.02,.03,.07,.12,.09,.27,.04,.42-.07,.22-.29,.37-.51,.36-.05,0-.11-.01-.16-.03Zm.64,1.96c-.05-.02-.1-.04-.14-.07-.09-.06-.14-.14-.18-.23-.05-.11-.05-.24-.01-.36,.09-.28,.39-.43,.66-.34,.1,.03,.19,.1,.25,.18,.06,.08,.1,.18,.11,.28,.01,.07,0,.14-.02,.21-.09,.28-.39,.43-.66,.34Zm1.29,1.62c-.09,.25-.34,.4-.59,.35-.02,0-.05-.01-.07-.02-.07-.03-.14-.06-.19-.12-.15-.13-.21-.34-.15-.55,.07-.23,.29-.37,.52-.36,.05,0,.1,.01,.15,.03,.05,.02,.09,.04,.13,.06,.19,.13,.28,.37,.21,.6Zm1.83-.39c-.29,0-.53-.24-.53-.52s.24-.53,.53-.53,.53,.24,.53,.53-.24,.52-.53,.52Zm1.21,1.67c-.29,0-.53-.24-.53-.53s.24-.52,.53-.52,.52,.23,.52,.52-.24,.53-.52,.53Zm1.2,1.66c-.29,0-.52-.24-.52-.52s.23-.53,.52-.53,.53,.24,.53,.53c0,.03,0,.06-.01,.1-.02,.13-.1,.25-.2,.32-.09,.07-.2,.11-.32,.11Zm2.15-1.47c-.19,.06-.39,.01-.52-.12-.06-.06-.11-.13-.13-.22-.01-.03-.02-.05-.02-.09-.04-.25,.11-.5,.36-.58,0,0,.01,0,.02,0,.12-.03,.23-.02,.34,.02,.01,0,.02,0,.03,.01,.13,.06,.23,.17,.28,.32,.07,.22-.02,.46-.2,.59-.04,.03-.09,.05-.14,.07Zm1.66,1.21c-.05,.02-.11,.03-.16,.03-.1,0-.2-.03-.28-.08-.1-.06-.18-.16-.22-.28-.09-.28,.06-.58,.34-.67,.1-.03,.2-.03,.3,0,.1,.03,.18,.08,.25,.16,.05,.05,.09,.11,.11,.19,.09,.27-.06,.58-.34,.66Zm1.73,1.19s-.05,.02-.07,.03c-.07,.03-.15,.03-.22,.02-.2-.02-.37-.16-.44-.36-.07-.22,.01-.46,.2-.59,.04-.03,.09-.05,.14-.07,.05-.02,.1-.02,.14-.02,.23-.01,.44,.13,.52,.36,.09,.25-.04,.51-.27,.64Zm1.52-2.03c-.24,.18-.56,.12-.74-.11-.17-.24-.12-.57,.12-.74,.23-.17,.56-.12,.73,.12,.17,.24,.12,.57-.12,.73Zm1.96,.64c-.24,.17-.57,.12-.74-.12-.17-.24-.12-.56,.12-.74,.23-.17,.57-.12,.73,.12,.18,.24,.12,.57-.11,.74Zm1.95,.64c-.24,.17-.56,.12-.74-.12-.17-.24-.12-.57,.12-.74,.23-.17,.56-.12,.73,.12,.02,.03,.04,.06,.05,.09,.05,.12,.06,.26,.02,.38-.03,.1-.09,.2-.19,.27Zm.88-2.45c-.12,.17-.32,.24-.5,.21-.08-.01-.16-.04-.23-.1-.03-.02-.05-.04-.07-.06-.18-.18-.2-.46-.05-.67,0,0,0-.01,.01-.01,.07-.1,.17-.16,.28-.19,.01,0,.02,0,.03,0,.14-.03,.28,0,.41,.09,.19,.14,.26,.38,.19,.59-.01,.05-.04,.1-.07,.14Zm1.66,.22c-.12,.01-.24-.02-.34-.1-.24-.17-.29-.5-.12-.73,.06-.09,.14-.15,.24-.18,.1-.04,.2-.05,.3-.02,.07,.01,.14,.04,.2,.09,.23,.17,.29,.5,.11,.74-.03,.04-.06,.08-.11,.11-.08,.06-.18,.11-.28,.11Zm2.45-.21c-.05,.06-.1,.11-.17,.14-.18,.1-.4,.1-.57-.03-.19-.13-.26-.39-.18-.6,.01-.05,.04-.09,.07-.13,.03-.04,.06-.07,.1-.11,.18-.14,.44-.15,.63-.01,.22,.16,.28,.45,.16,.67-.01,.02-.02,.04-.04,.06Zm2.03-3.23c-.09,.28-.39,.43-.66,.34-.28-.09-.43-.39-.34-.66,.09-.28,.39-.43,.66-.34,.28,.09,.43,.39,.34,.67Zm1.96-.64c-.09,.28-.39,.43-.67,.34-.28-.09-.43-.39-.34-.66,.09-.28,.39-.43,.67-.34,.03,.01,.05,.02,.08,.03,0,0,0,0,.01,0,.12,.06,.2,.18,.25,.3h0c.03,.11,.04,.21,0,.32Zm-.73-2.49c0,.2-.11,.38-.28,.47-.07,.04-.16,.06-.25,.06-.03,0-.06,0-.09-.01-.25-.04-.43-.26-.43-.52h0c0-.13,.05-.25,.12-.33,0-.01,.02-.02,.02-.03,.1-.11,.24-.17,.39-.17,.24,0,.44,.16,.5,.38,.02,.05,.03,.1,.03,.15Zm1.47-.8c-.09,.08-.2,.12-.33,.12-.29,0-.52-.24-.52-.52,0-.11,.03-.2,.09-.29,.06-.09,.14-.16,.24-.19,.06-.03,.13-.04,.2-.04,.29,0,.53,.24,.53,.52,0,.05-.01,.11-.03,.16-.03,.1-.09,.19-.17,.25Zm1.86-1.61c0,.07-.02,.15-.05,.21-.08,.18-.26,.31-.48,.31-.24,0-.44-.16-.51-.38-.02-.05-.02-.1-.02-.14,0-.05,0-.1,.03-.15,.06-.22,.27-.38,.5-.38,.27,0,.48,.2,.52,.45,0,.02,0,.05,0,.07Zm.96-5.48c.09,.28-.06,.58-.34,.67-.28,.09-.57-.06-.66-.34-.09-.28,.06-.58,.34-.67,.03-.01,.06-.02,.1-.02,.13-.02,.27,.02,.37,.1h0c.09,.06,.15,.16,.19,.26Z"
        />
        <path
          class="cls-703"
          d="M474.93,495.64s0-.1-.01-.14c0-.06,0-.11,0-.17,0-.05-.01-.09-.02-.14-.05-.59-.13-1.17-.26-1.73,0-.05-.02-.09-.03-.14-.01-.06-.02-.11-.04-.17-.01-.05-.02-.1-.03-.14-.5-2.04-1.45-3.91-2.74-5.48-.03-.04-.05-.07-.09-.11-.04-.04-.07-.09-.11-.13-.03-.04-.06-.07-.1-.11-.37-.44-.79-.86-1.23-1.25-.04-.04-.07-.07-.11-.1-.04-.04-.08-.08-.12-.11-.04-.04-.07-.07-.11-.1-1.25-1.05-2.68-1.89-4.24-2.46-.34-.13-.7-.24-1.05-.34-.05-.02-.1-.03-.15-.04-.04-.01-.09-.02-.14-.03-.05-.02-.11-.03-.17-.04-.04-.01-.09-.02-.13-.03-.14-.04-.29-.06-.43-.1-.35-.07-.71-.13-1.08-.17-.07-.01-.14-.02-.22-.03-.05,0-.1-.01-.14-.01-.05-.01-.11-.02-.17-.02-.05,0-.1-.01-.14-.01-.33-.03-.66-.04-1-.04-.77,0-1.53,.06-2.27,.18-.5,.08-1,.19-1.48,.33-.44,.12-.88,.27-1.31,.43-.04,.02-.09,.03-.13,.05-.05,.02-.11,.04-.16,.06-.04,.02-.09,.04-.13,.05-.54,.23-1.06,.49-1.57,.79-.04,.02-.09,.04-.13,.07-.05,.03-.1,.06-.14,.09-.04,.02-.08,.05-.12,.07-.17,.1-.33,.21-.49,.32-.41,.28-.8,.58-1.18,.9-.53,.45-1.03,.94-1.49,1.47-.44,.5-.85,1.04-1.21,1.6-.03,.04-.05,.08-.08,.12-.03,.04-.06,.09-.09,.14-.03,.04-.05,.08-.07,.12-.31,.5-.57,1.02-.81,1.56-.02,.04-.04,.09-.06,.13-.02,.05-.05,.1-.06,.16-.02,.04-.04,.09-.05,.13-.67,1.63-1.03,3.41-1.03,5.29,0,.25,0,.51,.02,.75,0,.05,0,.1,.01,.14,0,.05,0,.11,.02,.17,0,.05,0,.1,.01,.15,.03,.37,.07,.74,.14,1.1,.03,.2,.07,.41,.11,.61,0,0,0,.01,0,.02,0,.04,.02,.08,.03,.12,0,.01,0,.02,0,.03,.01,.05,.02,.11,.04,.16,.01,.05,.02,.1,.04,.14,.07,.34,.17,.67,.28,1,.08,.24,.17,.48,.26,.72,.53,1.38,1.27,2.64,2.19,3.77,.03,.04,.06,.07,.09,.11,.04,.04,.07,.09,.11,.13,.03,.04,.06,.07,.1,.11,.39,.44,.8,.86,1.23,1.25,.04,.04,.07,.07,.11,.1,.04,.04,.08,.07,.12,.11,.04,.03,.08,.06,.11,.09,1.56,1.32,3.41,2.3,5.44,2.83,.05,.02,.09,.03,.14,.04,.05,.02,.11,.03,.17,.04,.04,.01,.09,.02,.13,.03,.56,.13,1.14,.23,1.73,.29,.05,0,.1,.01,.14,.01,.05,.01,.11,.02,.17,.02,.04,0,.09,.01,.14,.01,.33,.03,.66,.04,1,.04,1.79,0,3.49-.33,5.06-.94,.05-.01,.09-.03,.13-.05,.05-.02,.11-.04,.16-.06,.04-.01,.09-.03,.13-.05,.55-.23,1.07-.49,1.57-.79,.04-.02,.09-.04,.12-.07,.05-.03,.1-.05,.14-.09,.04-.03,.09-.05,.12-.08,1.76-1.09,3.25-2.56,4.37-4.29,.03-.04,.05-.08,.07-.12,.04-.04,.06-.09,.09-.14,.03-.04,.05-.08,.08-.12,.3-.5,.57-1.02,.81-1.56,.02-.04,.04-.09,.06-.13,.03-.05,.05-.1,.06-.16,.02-.04,.04-.09,.05-.13,.67-1.63,1.03-3.41,1.03-5.29,0-.25,0-.5-.02-.75Zm-1.53-2.75c.13,.1,.24,.21,.34,.33,.07,.1,.14,.2,.2,.32,.05,.09,.09,.18,.12,.28,.13,.36,.14,.77,.04,1.16-.02,.07-.04,.13-.07,.2-.01,.03-.02,.05-.04,.07-.12,.27-.3,.5-.52,.68-.3,.26-.68,.42-1.08,.45-.31,.03-.62-.01-.93-.13-.04-.02-.07-.03-.11-.05-.2-.1-.39-.22-.53-.38-.08-.07-.14-.14-.2-.22-.28-.38-.42-.86-.37-1.34,0-.1,.03-.2,.05-.29,.02-.09,.05-.17,.08-.26,.1-.25,.25-.47,.43-.65,.04-.04,.09-.09,.14-.12,.12-.11,.25-.19,.4-.26,.48-.24,1.05-.27,1.58-.06,.17,.07,.33,.16,.46,.27Zm-.79-2.55c0,1.08-.88,1.96-1.96,1.96-.04,0-.09,0-.12,0-.53-.03-1-.28-1.33-.65-.05-.05-.09-.1-.13-.16-.24-.32-.37-.72-.37-1.15,0-.27,.05-.53,.16-.76,.29-.7,.99-1.2,1.8-1.2,.1,0,.19,0,.28,.02,.11,.01,.2,.04,.31,.07,.8,.25,1.38,1,1.38,1.87Zm-8.13-6.65s.06-.02,.1-.02c.34-.05,.68-.01,1,.12,.31,.12,.59,.33,.81,.61,.67,.86,.52,2.09-.34,2.75-.03,.03-.06,.05-.1,.07-.32,.22-.68,.33-1.04,.34h-.08c-.07,0-.15,0-.22-.02-.3-.03-.58-.14-.83-.3-.11-.07-.22-.16-.32-.26-.05-.05-.1-.11-.15-.17-.17-.21-.28-.45-.35-.7,0-.03-.02-.05-.02-.07-.08-.34-.06-.68,.04-1.01,.04-.15,.1-.29,.18-.42,.03-.05,.06-.1,.09-.14,.11-.16,.24-.29,.39-.41,.2-.16,.42-.26,.64-.33,.06-.02,.13-.04,.19-.05Zm-5.66,.24c.09-.16,.2-.29,.32-.41,.62-.6,1.58-.75,2.35-.3,0,0,0,0,0,0,.09,.05,.17,.11,.25,.17,.21,.17,.38,.37,.5,.6,.19,.35,.27,.77,.22,1.17h0c-.03,.25-.11,.5-.25,.73-.02,.04-.04,.07-.08,.11-.11,.16-.24,.3-.38,.42-.06,.05-.13,.1-.2,.15-.2,.12-.42,.21-.65,.26-.22,.05-.46,.05-.7,.02-.1-.01-.19-.03-.29-.07-.13-.04-.26-.1-.39-.17-.23-.13-.43-.31-.58-.51-.47-.61-.55-1.46-.14-2.16Zm-6.76,2.33c.29-.33,.71-.56,1.18-.63,.04,0,.09-.01,.13-.02,.1,0,.2,0,.3,0,.11,0,.21,.02,.31,.05,.75,.19,1.35,.81,1.47,1.63,0,.04,.01,.08,.02,.12,.04,.51-.12,.99-.42,1.36-.09,.12-.2,.23-.32,.32-.04,.03-.08,.06-.12,.09-.24,.16-.52,.27-.83,.32-.09,.01-.18,.02-.26,.02-.18,0-.35-.02-.51-.06-.64-.17-1.16-.66-1.36-1.3-.03-.1-.06-.21-.08-.32-.09-.59,.11-1.17,.49-1.58Zm-2.8,3.43c.06-.07,.13-.15,.21-.21,.09-.08,.19-.15,.29-.21,.02-.01,.05-.03,.07-.04,.17-.09,.34-.15,.52-.18,.56-.12,1.14,.02,1.59,.37,.14,.11,.27,.24,.38,.39,.05,.05,.09,.11,.12,.17,.02,.04,.04,.07,.05,.11,.15,.3,.22,.62,.2,.94v.05c0,.08-.02,.16-.03,.24h0c-.09,.47-.34,.89-.73,1.18-.07,.05-.14,.11-.22,.15-.01,0-.02,.01-.03,.02-.22,.13-.47,.2-.71,.24-.27,.03-.54,.01-.79-.06-.32-.09-.6-.26-.84-.49-.12-.12-.22-.26-.32-.41-.04-.08-.09-.16-.12-.24-.09-.21-.13-.44-.14-.66,0-.1,0-.2,.01-.29,.04-.39,.2-.77,.47-1.06Zm-.45,10.49c-.17-.07-.33-.16-.47-.27-.13-.1-.24-.21-.33-.33-.07-.09-.13-.19-.19-.29,0-.01-.01-.02-.02-.03-.05-.09-.09-.18-.11-.27-.05-.13-.09-.27-.1-.42-.03-.24-.02-.49,.05-.74,.02-.07,.04-.14,.07-.21,.01-.02,.02-.05,.03-.07,.1-.24,.25-.44,.43-.61,.03-.03,.06-.05,.09-.07,.3-.26,.68-.42,1.08-.45,.3-.03,.62,.01,.92,.13,.04,.02,.08,.03,.12,.05,.2,.1,.39,.22,.53,.38,.07,.07,.14,.14,.2,.22,.04,.05,.07,.1,.1,.15,.05,.09,.1,.19,.14,.29,.1,.24,.14,.49,.14,.74,0,.05,0,.1-.01,.16-.01,.1-.03,.2-.05,.29-.02,.09-.05,.17-.08,.26,0,0,0,0,0,.01-.1,.25-.25,.46-.42,.63-.04,.04-.09,.09-.14,.13-.09,.07-.18,.13-.27,.19-.04,.03-.09,.05-.13,.07-.29,.14-.61,.21-.94,.19-.21,0-.43-.05-.64-.13Zm.33,2.28c0-.57,.25-1.09,.64-1.44,.35-.32,.81-.51,1.32-.51,.04,0,.09,0,.12,0,.13,0,.25,.03,.37,.06h0c.37,.1,.71,.3,.96,.59,.05,.05,.09,.1,.13,.16,.24,.32,.37,.72,.37,1.15,0,.27-.05,.53-.16,.77-.29,.7-1,1.2-1.8,1.2-.1,0-.19,0-.28-.02-.11-.01-.21-.04-.31-.07-.8-.25-1.38-1-1.38-1.87Zm8.03,6.67c-.67,.1-1.37-.16-1.82-.73-.66-.86-.51-2.09,.34-2.75,.03-.03,.06-.05,.1-.07,.32-.22,.68-.34,1.05-.35,.1,0,.2,0,.3,.02,.42,.05,.83,.25,1.14,.57,.05,.05,.11,.11,.16,.17,.17,.21,.28,.45,.35,.7,.1,.36,.09,.74-.02,1.09-.04,.14-.1,.28-.18,.41-.02,.04-.04,.08-.08,.12-.1,.16-.24,.3-.4,.43-.2,.16-.42,.26-.64,.33-.1,.03-.19,.05-.29,.06Zm5.75-.25c-.54,.94-1.74,1.25-2.67,.72,0,0,0,0,0,0-.09-.05-.17-.11-.25-.17-.54-.44-.8-1.11-.72-1.78h0c.03-.25,.11-.5,.25-.73,.02-.04,.04-.07,.07-.11,.16-.24,.36-.43,.59-.57,.4-.25,.87-.35,1.34-.27,.1,.01,.19,.03,.29,.07,.13,.04,.26,.1,.39,.17,.23,.13,.43,.31,.58,.51,.47,.61,.55,1.47,.14,2.17Zm5.58-1.7c-.15,.02-.29,.03-.43,.01-.11,0-.21-.02-.31-.05-.75-.19-1.35-.82-1.47-1.63,0-.04-.01-.08-.02-.12-.05-.67,.24-1.29,.74-1.69,.04-.03,.08-.06,.12-.09,0,0,0,0,0,0,.24-.16,.52-.27,.82-.31,.27-.04,.53-.02,.78,.04,.74,.2,1.33,.82,1.44,1.62,.15,1.07-.6,2.07-1.67,2.22Zm3.98-4.06c-.06,.07-.13,.15-.21,.21-.09,.08-.18,.15-.28,.21-.02,.01-.05,.03-.07,.04-.17,.09-.34,.15-.52,.18-.56,.12-1.14-.02-1.59-.37-.14-.11-.27-.24-.38-.39-.05-.05-.09-.11-.12-.17-.02-.04-.04-.07-.05-.11-.15-.3-.21-.62-.2-.94,0-.1,.01-.19,.03-.29,.08-.46,.33-.89,.72-1.19,.07-.05,.14-.11,.22-.15,.01,0,.02-.01,.03-.02,.22-.12,.47-.2,.71-.23,.26-.03,.52-.01,.78,.06,.48,.13,.9,.44,1.17,.9,.05,.08,.09,.17,.12,.25,.09,.21,.13,.43,.13,.65,0,.1,0,.2-.01,.29-.04,.39-.2,.77-.47,1.06Z"
        />
        <g>
          <path
            class="cls-617"
            d="M471.36,496.4c0,1.23-.21,2.4-.6,3.49-.35,1.02-.87,1.96-1.5,2.81-.17,.22-.34,.43-.52,.64-.71,.8-1.53,1.49-2.46,2.04-1.05,.64-2.23,1.1-3.49,1.32-.62,.12-1.26,.18-1.92,.18-.43,0-.85-.03-1.26-.08-.28-.03-.55-.07-.82-.13-1.06-.21-2.08-.59-3-1.1-1.1-.61-2.08-1.41-2.89-2.36-.66-.77-1.21-1.64-1.62-2.58-.02-.04-.04-.09-.06-.13-.11-.26-.21-.51-.29-.78-.07-.2-.13-.4-.18-.6-.05-.18-.09-.35-.13-.53-.09-.4-.15-.8-.19-1.21-.03-.26-.04-.53-.04-.8,0-.06,0-.13,0-.19,0-1.23,.21-2.4,.6-3.49,.28-.8,.65-1.55,1.11-2.25,.12-.19,.25-.38,.39-.56,.17-.22,.34-.43,.52-.64,.05-.06,.11-.13,.17-.19,.67-.72,1.44-1.35,2.29-1.86,1.05-.64,2.23-1.09,3.49-1.32,.62-.12,1.26-.18,1.91-.18,.43,0,.85,.03,1.27,.08,.27,.03,.54,.07,.79,.12,.01,0,.02,0,.03,0,.71,.14,1.39,.35,2.03,.63,.33,.14,.65,.3,.96,.47,1.1,.61,2.08,1.41,2.89,2.36,.69,.81,1.26,1.72,1.68,2.71,.11,.25,.21,.51,.29,.77,.33,.99,.52,2.04,.54,3.14,0,.06,0,.13,0,.19Z"
          />
          <path
            class="cls-802"
            d="M467.91,490.34c0-.41-.33-.74-.74-.74s-.74,.33-.74,.74,.33,.74,.74,.74,.74-.33,.74-.74Z"
          />
          <path
            class="cls-803"
            d="M464.84,488.01c-.17-.37-.6-.54-.98-.38-.37,.17-.54,.6-.38,.98,.17,.37,.6,.54,.98,.38s.54-.6,.38-.98Z"
          />
          <path
            class="cls-801"
            d="M461.08,487.12c-.3-.27-.77-.25-1.05,.05-.27,.3-.25,.77,.05,1.05,.3,.27,.77,.25,1.05-.05,.27-.3,.25-.77-.05-1.05Z"
          />
          <path
            class="cls-806"
            d="M457.29,487.84c-.39-.13-.81,.09-.93,.48s.09,.81,.48,.93c.39,.13,.81-.09,.93-.48,.13-.39-.09-.81-.48-.93Z"
          />
          <path
            class="cls-804"
            d="M454.12,490.04c-.41,.04-.7,.41-.66,.81,.04,.41,.41,.7,.81,.66,.41-.04,.7-.41,.66-.81-.04-.41-.41-.7-.81-.66Z"
          />
          <path
            class="cls-805"
            d="M452.12,493.34c-.35,.2-.48,.66-.27,1.01,.2,.35,.66,.48,1.01,.27,.35-.2,.48-.66,.27-1.01-.2-.35-.66-.48-1.01-.27Z"
          />
          <path
            class="cls-807"
            d="M451.63,497.16c-.24,.33-.17,.79,.16,1.03,.33,.24,.79,.17,1.03-.16,.24-.33,.17-.79-.16-1.03-.33-.24-.79-.17-1.03,.16Z"
          />
          <path
            class="cls-811"
            d="M452.74,500.86c-.09,.4,.17,.79,.57,.88,.4,.09,.79-.17,.88-.57,.09-.4-.17-.79-.57-.88s-.79,.17-.88,.57Z"
          />
          <path
            class="cls-809"
            d="M455.26,503.78c.09,.4,.48,.66,.88,.57,.4-.09,.66-.48,.57-.88-.09-.4-.48-.66-.88-.57-.4,.09-.66,.48-.57,.88Z"
          />
          <path
            class="cls-810"
            d="M458.75,505.43c.24,.33,.7,.4,1.03,.16,.33-.24,.4-.7,.16-1.03-.24-.33-.7-.4-1.03-.16-.33,.24-.4,.7-.16,1.03Z"
          />
          <path
            class="cls-813"
            d="M462.61,505.51c.35,.2,.81,.08,1.01-.27,.2-.35,.08-.81-.27-1.01-.35-.2-.81-.08-1.01,.27-.2,.35-.08,.81,.27,1.01Z"
          />
          <path
            class="cls-814"
            d="M466.17,504.02c.41,.04,.77-.25,.81-.66s-.25-.77-.66-.81-.77,.25-.81,.66c-.04,.41,.25,.77,.66,.81Z"
          />
          <path
            class="cls-812"
            d="M468.81,501.21c.39-.13,.6-.54,.48-.93-.13-.39-.54-.6-.93-.48s-.6,.54-.48,.93,.54,.6,.93,.48Z"
          />
          <path
            class="cls-797"
            d="M470.08,497.57c.3-.27,.33-.74,.05-1.05-.27-.3-.74-.33-1.05-.05-.3,.27-.33,.74-.05,1.05,.27,.3,.74,.33,1.05,.05Z"
          />
          <path
            class="cls-798"
            d="M469.76,493.72c.17-.37,0-.81-.38-.98-.37-.17-.81,0-.98,.38-.17,.37,0,.81,.38,.98,.37,.17,.81,0,.98-.38Z"
          />
          <g>
            <path
              class="cls-314"
              d="M467.69,490.34c0-.29-.23-.52-.52-.52s-.52,.23-.52,.52,.23,.52,.52,.52,.52-.23,.52-.52Z"
            />
            <path
              class="cls-314"
              d="M464.64,488.1c-.12-.26-.42-.38-.68-.26-.26,.12-.38,.42-.26,.68,.12,.26,.42,.38,.68,.26,.26-.12,.38-.42,.26-.68Z"
            />
            <path
              class="cls-314"
              d="M460.93,487.29c-.21-.19-.54-.17-.73,.04-.19,.21-.17,.54,.04,.73s.54,.17,.73-.04,.17-.54-.04-.73Z"
            />
            <path
              class="cls-314"
              d="M457.22,488.05c-.27-.09-.56,.06-.65,.33-.09,.27,.06,.56,.33,.65,.27,.09,.56-.06,.65-.33,.09-.27-.06-.56-.33-.65Z"
            />
            <path
              class="cls-314"
              d="M454.15,490.26c-.28,.03-.49,.29-.46,.57,.03,.28,.29,.49,.57,.46,.28-.03,.49-.29,.46-.57s-.29-.49-.57-.46Z"
            />
            <path
              class="cls-314"
              d="M452.23,493.53c-.25,.14-.33,.46-.19,.71,.14,.25,.46,.33,.71,.19,.25-.14,.33-.46,.19-.71s-.46-.33-.71-.19Z"
            />
            <path
              class="cls-314"
              d="M451.81,497.29c-.17,.23-.12,.56,.11,.72,.23,.17,.56,.12,.72-.11,.17-.23,.12-.56-.11-.72-.23-.17-.56-.12-.72,.11Z"
            />
            <path
              class="cls-314"
              d="M452.96,500.9c-.06,.28,.12,.56,.4,.62,.28,.06,.56-.12,.62-.4,.06-.28-.12-.56-.4-.62-.28-.06-.56,.12-.62,.4Z"
            />
            <path
              class="cls-314"
              d="M455.48,503.73c.06,.28,.33,.46,.62,.4,.28-.06,.46-.33,.4-.62-.06-.28-.33-.46-.62-.4-.28,.06-.46,.33-.4,.62Z"
            />
            <path
              class="cls-314"
              d="M458.93,505.3c.17,.23,.49,.28,.72,.11,.23-.17,.28-.49,.11-.72-.17-.23-.49-.28-.72-.11-.23,.17-.28,.49-.11,.72Z"
            />
            <path
              class="cls-314"
              d="M462.72,505.32c.25,.14,.57,.06,.71-.19,.14-.25,.06-.57-.19-.71-.25-.14-.57-.06-.71,.19-.14,.25-.06,.57,.19,.71Z"
            />
            <path
              class="cls-314"
              d="M466.19,503.8c.28,.03,.54-.18,.57-.46,.03-.28-.18-.54-.46-.57-.28-.03-.54,.18-.57,.46-.03,.28,.18,.54,.46,.57Z"
            />
            <path
              class="cls-314"
              d="M468.74,501c.27-.09,.42-.38,.33-.65-.09-.27-.38-.42-.65-.33-.27,.09-.42,.38-.33,.65,.09,.27,.38,.42,.65,.33Z"
            />
            <path
              class="cls-314"
              d="M469.93,497.4c.21-.19,.23-.52,.04-.73-.19-.21-.52-.23-.73-.04s-.23,.52-.04,.73c.19,.21,.52,.23,.73,.04Z"
            />
            <path
              class="cls-314"
              d="M469.56,493.63c.12-.26,0-.57-.26-.68-.26-.12-.57,0-.68,.26s0,.57,.26,.68c.26,.12,.57,0,.68-.26Z"
            />
          </g>
        </g>
      </g>
      <g class="cls-738">
        <path
          class="cls-109"
          d="M462.96,486.12c.71,.14,1.39,.35,2.03,.63l-.16,.81-.06,.33-.09,.45v.02s-.02,.1-.02,.1v.02s-.1,.45-.1,.45l-1.43,7.24-1.91-1.39,1.72-8.67v-.07s.02,.05,.03,.07Z"
        />
        <path
          class="cls-109"
          d="M466.54,478.92l-.15,.75-.16,.79-.54,2.71-.12,.62c-.63-.25-1.36-.17-1.93,.27-.16,.12-.28,.26-.39,.41l.37-1.89,.83-4.21c.71,.14,1.4,.32,2.08,.54Z"
        />
        <path
          class="cls-109"
          d="M471.23,455.23l-.73,3.69-.09,.42-.81,4.09-.04,.19-.05,.29-.03,.16-.04,.19-.11,.55-.05,.25-.17,.86-.05,.24c-.68-.19-1.38-.35-2.09-.49l.05-.24,.17-.86,.05-.25,.11-.54h0s.04-.2,.04-.2l.03-.15,.05-.28,.04-.2,.81-4.09,.09-.42,.65-3.29h0s.06-.3,.06-.3v-.04s.09,.02,.09,.02l.64,.13h0l1.38,.27Z"
        />
        <path
          class="cls-109"
          d="M430.93,505.64l-.24,.06-.85,.21-.24,.06-.55,.13-.14,.03h-.04s-.16,.05-.16,.05l-.43,.11h-.04s-4.05,1.01-4.05,1.01l-.42,.11-2.84,.7-.51-2.08,1.06-.26h0l.11-.03,.32-.08,1.31-.32,.42-.1,4.05-1,.06-.02,.42-.1,.15-.04h.06s.12-.04,.12-.04l.54-.13,.24-.06,.85-.21,.24-.06c.16,.7,.35,1.39,.56,2.07Z"
        />
        <path
          class="cls-109"
          d="M461.57,498.11l-9.96,2.45h0l-.31,.07s-.04-.09-.06-.13c-.04,0-.08,0-.12,0-.51,0-.97,.19-1.32,.51l-2.03,.5-.73,.18-.87,.21-2.59,.64c-.24-.67-.44-1.36-.59-2.06l4.17-1.02,.68-.17,2.8-.68,.88-.22,.42-.1,.88-.21h0l6.5-1.6,2.26,1.65Z"
        />
      </g>
      <g>
        <polygon
          class="cls-526"
          points="462.12 495.64 470.22 454.69 468.12 454.28 460.21 494.25 462.12 495.64"
        />
        <polygon
          class="cls-526"
          points="458.3 495.93 419.43 505.48 419.94 507.56 460.56 497.58 458.3 495.93"
        />
      </g>
      <path
        class="cls-533"
        d="M482.81,459.38l-1.46,.65h-.01s-.2,.1-.2,.1l-.68,.3-.6,.27c-1.06,.48-2.27,.51-3.37,.09-1.19-.45-2.41-.86-3.64-1.19-.01,0-.02-.01-.03-.01-3.54-.97-7.21-1.47-10.92-1.43-6.2,.04-12.48,1.54-18.34,4.64-11.31,5.99-18.55,16.66-20.59,28.36-.59,3.4-.75,6.89-.44,10.37,0,.01,0,.02,0,.03,.31,3.5,1.09,6.99,2.37,10.4,.18,.48,.14,1-.09,1.46-.47,.91-1.02,1.8-1.59,2.64-.05,.08-.1,.16-.16,.24-.01,.02-.03,.04-.05,.06,0,0,0,0,0,0-.05,.07-.1,.14-.16,.21-.16-.3-.31-.6-.47-.91-2.91-5.79-4.55-12.33-4.55-19.26,0-.72,.03-1.44,.06-2.16t0-.01c0-.07,.01-.13,.01-.2h0c0-.07,0-.14,.02-.21,0-.11,.01-.22,.02-.33,0-.08,.01-.16,.02-.24,0,0,0,.01,0,.02v-.02c.16-2.2,.49-4.35,.97-6.44h0c.01-.06,.03-.13,.04-.19h0s0-.02,0-.03c.06-.25,.12-.49,.18-.73h0c.54-2.13,1.23-4.21,2.08-6.19,.03-.06,.05-.13,.08-.19,.1-.24,.2-.48,.31-.72,.89-1.99,1.94-3.91,3.12-5.72h0s.04-.06,.05-.09c.02-.03,.04-.05,.05-.09h0c.14-.21,.29-.43,.43-.65h0c1.22-1.8,2.57-3.5,4.06-5.09t0-.01s.09-.09,.13-.13c0,0,0,0,0,0h0s0-.01,0-.01c.17-.19,.35-.37,.52-.55h0s0-.01,0-.02c.93-.95,1.9-1.87,2.91-2.72,.37-.33,.76-.64,1.15-.95,.27-.21,.54-.42,.81-.63,0,0,0-.01,.01-.02,.03-.02,.06-.04,.09-.06,.02-.02,.05-.04,.07-.05,.21-.16,.41-.3,.63-.46,0,0,0,0,.01,0,.75-.55,1.54-1.07,2.33-1.57,.35-.22,.69-.43,1.04-.64,.47-.27,.93-.54,1.4-.79,1.65-.89,3.36-1.67,5.13-2.34,.86-.33,1.73-.62,2.62-.89h0c.06-.02,.13-.04,.19-.06,.24-.08,.49-.15,.74-.22,0,0,0,.01,0,.01,2.07-.6,4.21-1.04,6.4-1.31h0c.06-.01,.13-.02,.2-.03,0,0,0,0,0,0,.26-.04,.52-.06,.78-.09h0c1.43-.14,2.88-.22,4.34-.22,.73,0,1.45,.02,2.17,.05,.07,0,.13,.01,.2,.01h0c.26,.02,.52,.03,.78,.05,4.38,.32,8.58,1.29,12.5,2.83,.67,.26,1.33,.54,1.98,.84,1.06,.47,2.09,.99,3.1,1.55,.41,.22,.81,.45,1.2,.68Z"
      />
      <path
        class="cls-315"
        d="M486.92,455.34l-6.32,2.82-2.1,.94c-1.06,.48-2.27,.51-3.36,.09-1.02-.39-2.06-.74-3.11-1.04-.1-.03-.2-.06-.29-.09-.02,0-.04-.01-.05-.02h0c-.32-.09-.63-.18-.95-.26-.36-.09-.71-.18-1.07-.26-.34-.07-.68-.15-1.02-.21-.35-.07-.72-.14-1.08-.2-.78-.13-1.55-.25-2.33-.33-.11-.01-.21-.02-.31-.03-.02,0-.04,0-.06,0-2.18-.22-4.38-.26-6.58-.12-.1,0-.21,.01-.31,.02-.02,0-.04,0-.06,0-2.17,.16-4.34,.5-6.49,1.02-.1,.03-.2,.05-.3,.08-.02,0-.04,0-.06,.02-1.33,.34-2.66,.75-3.97,1.24-.46,.17-.91,.34-1.37,.54-.25,.1-.5,.21-.75,.32-.05,.02-.09,.04-.14,.06-.09,.04-.18,.07-.27,.12-.02,.01-.04,.02-.06,.03-.77,.35-1.52,.72-2.28,1.12-.72,.38-1.42,.78-2.11,1.21-.17,.1-.34,.2-.5,.3-.25,.16-.49,.32-.73,.48-.04,.02-.08,.04-.12,.07-.09,.05-.17,.11-.26,.17-.02,.01-.04,.02-.05,.04-1.84,1.25-3.55,2.63-5.12,4.13h0c-.07,.07-.15,.14-.22,.21-.02,.02-.03,.03-.04,.04-1.58,1.54-3.02,3.2-4.3,4.95-.07,.09-.13,.18-.19,.26-.01,.02-.03,.03-.04,.05-1.28,1.79-2.41,3.68-3.38,5.64-.04,.09-.09,.18-.13,.28-.01,.02-.02,.04-.03,.06-.95,1.98-1.74,4.03-2.35,6.14-.03,.1-.06,.19-.08,.29-.01,.02-.02,.04-.02,.06-.59,2.11-1.02,4.26-1.25,6.45-.02,.1-.03,.2-.04,.31,0,.02,0,.04,0,.06-.22,2.17-.27,4.37-.12,6.57,.01,.1,.02,.21,.03,.32,0,.02,0,.04,0,.06,.13,1.84,.4,3.68,.8,5.51,.05,.25,.11,.49,.17,.74,.02,.08,.04,.17,.06,.25,.02,.1,.05,.2,.07,.3,0,.02,0,.04,.02,.05,.06,.25,.12,.49,.19,.73,.06,.25,.13,.49,.21,.73,.26,.9,.56,1.79,.89,2.68,.18,.48,.15,1-.09,1.46,0,.01-.01,.03-.02,.04-.04,.08-.09,.16-.13,.24-.01,.03-.03,.05-.04,.08-.44,.81-.93,1.59-1.43,2.33-1.79,2.6-3.82,4.7-4.72,5.59-.11,.1-.23,.15-.36,.15-.28,0-.47-.36-.5-.43-12.28-23.4-4.34-52.08,17.66-65.98,.25-.16,.49-.3,.74-.45,.17-.11,.34-.21,.51-.3,.69-.41,1.4-.81,2.11-1.19,.9-.48,1.82-.93,2.74-1.35l.75-.34c.45-.2,.9-.39,1.35-.57,15.07-6.06,31.7-4.31,44.93,3.71,.78,.48,.7,1.64-.13,2.01Z"
      />
    </g>
    <g>
      <path
        class="cls-971"
        d="M463.44,495.95l-.03,.02-.27,.14-.06,.03-2.45,1.3-.16,.08-.2,.11-.07,.04-1.14,.6-.21-.27-.56-.72c-.12-.16-.25-.32-.35-.48-.17-.22-.32-.44-.47-.66-.51-.74-.97-1.5-1.39-2.28l-1.36-2.56-.11-.22-.43-.81-.11-.2-.29-.55-.29-.55-1.43-2.7-.3-.57-.34-.65-.48-.91-1.22-2.31-.65-1.22-.37-.7-5.1-9.64-.11-.21-.41-.77-.12-.22-.24-.44-.03-.06-.09-.16-.07-.14-.11-.21-.12-.22-.79-1.49-.94-1.77-.24-.44-.2-.38-.55-1.03-.35-.67-.16-.3-.05-.1h0s-.93-1.74-.93-1.74l-3.45-6.52-11.91-22.48-2.45-4.62-.37-.71-1.88-3.55,.54-.29,4.82-2.55,1.88,3.55,.37,.71,3.95,7.47,10.4,19.64,3.45,6.52,1.25,2.35,.05,.1,.15,.28,.05,.09,.54,1.02,.21,.39,.2,.38,.97,1.83,.79,1.48,.12,.23,.11,.2,.07,.14,.1,.17,.03,.06,.24,.44,.12,.22,.41,.77,.11,.21,1.36,2.56,.51,.96,4.25,8.03,.07,.14,.32,.6v.03s.33,.59,.33,.59l1.32,2.49,1.73,3.28,2.16,4.07,.43,.82c.13,.24,.25,.48,.37,.73,.27,.55,.51,1.11,.73,1.68,.18,.44,.34,.89,.49,1.35l.22,.68,.15,.46,.02,.04Z"
      />
      <polygon
        class="cls-800"
        points="429.62 430.88 422.75 430.88 420.3 426.26 419.93 425.55 418.04 422 418.59 421.71 423.41 419.15 425.29 422.71 425.66 423.41 429.62 430.88"
      />
      <g>
        <path
          class="cls-375"
          d="M425.66,422.51l-.37,.2-4.82,2.55-.55,.29-.37,.2c-.2,.11-.44,.06-.53-.1l-11.66-22c-.24-.45-.07-1.02,.39-1.26l5.21-2.76c.33-.17,.71-.13,.98,.07,.11,.08,.21,.19,.28,.32l11.66,22c.09,.16-.01,.38-.21,.49Z"
        />
        <path
          class="cls-375"
          d="M447.09,463.37l-.21,.11-4.84,2.56-.52,.27-.27,.14c-.28,.15-.63,.04-.78-.24l-.63-1.19-.24-.44-.2-.37-.55-1.03-.05-.1-.17-.32-.06-.11-1.21-2.29-3.46-6.54-14.21-26.87c-.09-.17,.01-.39,.21-.49l.37-.2,1.29-.68,4.07-2.16,.37-.2c.21-.11,.44-.06,.53,.1l14.21,26.87,3.45,6.53,1,1.9,.05,.09,.14,.27,.3,.57,.54,1.02,.2,.39,.2,.37,.67,1.27c.15,.28,.04,.63-.24,.78Z"
        />
      </g>
    </g>
    <path
      class="cls-703"
      d="M463.4,495.06c-.74-1.39-2.47-1.92-3.86-1.18-1.39,.74-1.92,2.47-1.18,3.86s2.47,1.92,3.86,1.18,1.92-2.47,1.18-3.86Z"
    />
    <path
      class="cls-617"
      d="M462.28,495.66c-.41-.77-1.37-1.07-2.14-.66-.77,.41-1.07,1.37-.66,2.14,.41,.77,1.37,1.07,2.14,.66,.77-.41,1.07-1.37,.66-2.14Z"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
